import {
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  startCoroutine1brije5juseye as startCoroutine,
  constructCallableReference23y65rf941mch as constructCallableReference,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Continuation1aa2oekvx7jm7 as Continuation,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  Result__exceptionOrNull_impl_p6xea92zjvgyei8ws1 as Result__exceptionOrNull_impl_p6xea9,
  printStackTrace18lnx7a39cni as printStackTrace,
  _Result___get_isFailure__impl__jpirivaggyjf2c4e0j as _Result___get_isFailure__impl__jpiriv,
  CancellationException3b36o9qz53rgr as CancellationException,
  DurationUnit_SECONDS_getInstancehu17fry790z2 as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  lazy2hsh8ze7j6ikd as lazy,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  fromInt1lka3ktyu79a4 as fromInt,
  subtract16cg4lfi29fq9 as subtract,
  compare2uud5j30pw5xc as compare,
  convertToIntofdoxh9bstof as convertToInt,
  add85si75olwt6n as add,
  Long2qws0ah9gnpki as Long,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  endsWith3cq61xxngobwh as endsWith,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimEndvvzjdhan75g as trimEnd,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  removeAll3o43e67jmwdpc as removeAll,
  sortWith4fnm6b3vw03s as sortWith,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  hashCodeq5arwsb9dgti as hashCode,
  compareValues1n2ayl87ihzfk as compareValues,
  to2cs3ny02qtbcb as to,
  substring3saq8ornu0luv as substring,
  startsWith26w8qjqapeeq6 as startsWith,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  until32cjhie5unyfs as until,
  toString30pk9tzaqopn as toString_0,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  Exceptiondt2hlxn7j7vw as Exception,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  Regexxgw0gjiagf4z as Regex,
  substringBefore3n7kj60w69hju as substringBefore,
  dropLastlqc2oyv04br0 as dropLast,
  split2bvyvnrlcifjv as split,
  getOrNull1go7ef9ldk0df as getOrNull,
  substringAfter1hku067gwr5ve as substringAfter,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  substringBeforekje8w2lxhyb6 as substringBefore_0,
  contains3ue2qo8xhmpf1 as contains,
  isBlank1dvkhjjvox3p0 as isBlank,
  substringBeforeLastqh7oeuvefdek as substringBeforeLast,
  trimStart1mkod6gyztuyy as trimStart,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  KProperty1ca4yb4wlo496 as KProperty1,
  StringBuildermazzzhj6kkai as StringBuilder,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char19o2r8palgjof as Char,
  split3d3yeauc4rm2n as split_0,
  toMutableList20rdgwi7d3cwi as toMutableList,
  toString336ienavfnzn0 as toString_1,
  joinToString1cxrrlmo0chqs as joinToString,
  listOf1jh22dvmctj1r as listOf,
  toMap1vec9topfei08 as toMap,
  Enum3alwj03lh1n41 as Enum,
  captureStack1fzi4aczwc4hg as captureStack,
  createThis2j2avj17cvnv2 as createThis,
  toList383f556t1dixk as toList,
  equals2v6cggk171b6e as equals_0,
  first58ocm7j58k3q as first,
  sortedWith2csnbbb21k0lg as sortedWith,
  toSet2orjxp16sotqu as toSet,
  toList3jhuyej2anx2q as toList_0,
  plus310ted5e4i90h as plus,
  Iterable1y3qizuf89iou as Iterable,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  Collection1k04j3hzsbod0 as Collection,
  linkedMapOf1is69t4zkcfr3 as linkedMapOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toIntOrNull1j8dcc6to13o4 as toIntOrNull_0,
  longRangeToLong1wnzlyc7cu6kp as longRangeToLong,
  substringiqarkczpya5m as substring_0,
  charArray2ujmm1qusno00 as charArray,
  charCodeAt1yspne1d8erbm as charCodeAt,
  StringCompanionObject_instance3btc7up7fjjpg as StringCompanionObject_instance,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  println2shhhgwwt4c61 as println,
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  emptyList1g2z5xcrvp2zy as emptyList,
  EmptyCoroutineContext_getInstance2wsqunjuleo79 as EmptyCoroutineContext_getInstance,
  numberToLong345n6tb1n1i71 as numberToLong,
  newThrowablezl37abp36p5f as newThrowable,
  toNumberlmbpvqo27r53 as toNumber,
  toInt5qdj874w69jh as toInt,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  isByteArray4nnzfn1x4o3w as isByteArray,
  drop258un2a8hqa2a as drop,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  lines3g90sq0zeq43v as lines,
  trimEnd17pt8cbotbalj as trimEnd_0,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  firstOrNull1982767dljvdy as firstOrNull,
  contains2el4s70rdq4ld as contains_0,
  arrayListOf1fz8nib0ncbow as arrayListOf,
} from './kotlin-kotlin-stdlib.mjs';
import {
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  CoroutineStart_UNDISPATCHED_getInstance2pq896dvru5v1 as CoroutineStart_UNDISPATCHED_getInstance,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  launch1c91vkjzdi9sd as launch,
  completeWith2hvdlbg1q1mlx as completeWith,
  withContextqz5k6d9p9xx5 as withContext,
  delay3e2ei0hoxjoud as delay,
  await3gx2tubo6ckuc as await_0,
  Deferred6wjx2us769ee as Deferred,
} from './kotlinx-coroutines-core.mjs';
import {
  Companion_instanceubj3e1ju0kss as Companion_instance_0,
  FileNotFoundException2tz8ve019qipn as FileNotFoundException,
  Companion_getInstance1ju3fwn4mt9wh as Companion_getInstance,
  unsupported198cz39rr1ztw as unsupported,
  MalformedInputException12cxjt7zq8psv as MalformedInputException,
  IOException33c9ezfvq1zr9 as IOException,
  jsObjectr1r5ao37ef4f as jsObject,
  get_jsGlobalThis3odmbn60utci as get_jsGlobalThis,
  jsNewco39te1yl3up as jsNew,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  Level_ERROR_getInstance1195cgr5fzwj1 as Level_ERROR_getInstance,
  Companion_getInstance3f9e8v90vvgdj as Companion_getInstance_0,
  Level_INFO_getInstance2u0wredwjoo6m as Level_INFO_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  Proxy2ri7nr2ijtx4g as Proxy,
  VfsOpenMode_READ_getInstance3qf5ep0pmw6s7 as VfsOpenMode_READ_getInstance,
  VfsCachedStatContext2gte5m09f8ox9 as VfsCachedStatContext,
  _PathInfo___init__impl__vpw96a3sb4896r1qzn4 as _PathInfo___init__impl__vpw96a,
  normalize34ppus0f5oo02 as normalize,
  get_baseName7iz3sifr1imo as get_baseName,
  get_parent1emraos91g459 as get_parent,
  _PathInfo___get_fullPath__impl__21fx6xos59ykam8fuk as _PathInfo___get_fullPath__impl__21fx6x,
  get_baseName2yf63efofm8te as get_baseName_0,
  get_pathInfo26tycr2r540oz as get_pathInfo,
  UrlVfs292f1sja450ff as UrlVfs,
  Companion_instance2ce9qcs6y3vbs as Companion_instance_1,
  Vfs3mgmizq3oi7gy as Vfs,
  LocalVfs18bzski76hhpp as LocalVfs,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import {
  AsyncStreamBaseze8sfl15nwf0 as AsyncStreamBase,
  openAsync37anb1e84urmo as openAsync,
  toAsyncStream3ow20wz4trxzb as toAsyncStream,
  buffered29ldm4q6ez2xm as buffered,
  readAll1k0zte4qdypit as readAll,
  asyncStreamWriter38isk6dcvpewr as asyncStreamWriter,
  readLine1qo67k5yfh94w as readLine,
  readBytesExact9lk5ofbmnwn5 as readBytesExact,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  FastStringMap1l1uzdhsfbatm as FastStringMap,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import { Companion_getInstanceupvgqfr8b1ba as Companion_getInstance_1 } from './korlibs-serialization-root-korlibs-serialization.mjs';
import {
  get_dynw5edstkdie96 as get_dyn,
  _Dyn___get_value__impl__bemnlg10mbzoqpdd16f as _Dyn___get_value__impl__bemnlg,
  _Dyn___get_keys__impl__o4xmor3hrxjaghe7b4m as _Dyn___get_keys__impl__o4xmor,
  _Dyn___get_str__impl__dup4cs1e13jizv0c0lq as _Dyn___get_str__impl__dup4cs,
  Dyn__get_impl_6l2p8026w7xig66mqln as Dyn__get_impl_6l2p80,
  Dyn__get_impl_6l2p8025myyq9ua90y3 as Dyn__get_impl_6l2p80_0,
  Dyn__toLongOrNull_impl_ws7y8jk9c4t8xq7xii as Dyn__toLongOrNull_impl_ws7y8j,
  _Dyn___get_list__impl__qpwjp3gpcamqgpclhs as _Dyn___get_list__impl__qpwjp,
  _Dyn___get_bool__impl__nv3iun1zmxsid1d2p5t as _Dyn___get_bool__impl__nv3iun,
  _Dyn___get_long__impl__wdxl7nqnro6icquhnp as _Dyn___get_long__impl__wdxl7n,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import {
  Companion_getInstance9zqhf8dpcsyh as Companion_getInstance_2,
  _FastDuration___get_milliseconds__impl__ffr17u2qdtidjobg7a0 as _FastDuration___get_milliseconds__impl__ffr17u,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  substringAfterOrNull6pqoc8ojvu1x as substringAfterOrNull,
  substringBeforeOrNullyyd9hl5du3pj as substringBeforeOrNull,
  get_UTF82geyfhi1l22xl as get_UTF8,
  toString2x583ovdqfjci as toString_2,
  INDENTS_getInstance100uyhd8ddvwu as INDENTS_getInstance,
  substringEqualse7vi4930fev5 as substringEquals,
  toStringContext20qw1vqodfj0k as toStringContext,
  SimpleStrReader35udnj8g5ojo6 as SimpleStrReader,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  Companion_getInstance34rsdhmwl8tit as Companion_getInstance_3,
  uncompressed2z67snkddol6y as uncompressed,
  get_Deflate2a0lyute7oxjd as get_Deflate,
} from './korlibs-compression-root-korlibs-compression.mjs';
import { Companion_getInstance1e9v47ur0qkb5 as Companion_getInstance_4 } from './korlibs-io-network-core-root-korlibs-io-network-core.mjs';
import { arraycopy3czrd9re36wzt as arraycopy } from './korlibs-memory-root-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class launchUnscopedAndWait$2 {
  constructor($this_launchUnscopedAndWait, $deferred) {
    this.fbr_1 = $deferred;
    this.ebr_1 = $this_launchUnscopedAndWait;
  }
  od() {
    return this.ebr_1;
  }
  qd(result) {
    completeWith(this.fbr_1, result);
  }
}
class launchUnscoped$1 {
  constructor($this_launchUnscoped) {
    this.gbr_1 = $this_launchUnscoped;
  }
  od() {
    return this.gbr_1;
  }
  cn(result) {
    if (_Result___get_isFailure__impl__jpiriv(result)) {
      var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(result);
      if (tmp0_safe_receiver == null)
        null;
      else {
        printStackTrace(tmp0_safe_receiver);
      }
    }
  }
  qd(result) {
    return this.cn(result);
  }
}
class CatalogVfs$open$2 extends AsyncStreamBase {
  constructor(this$0, $base, $maxSize) {
    return new.target.kbr(this$0, $base, $maxSize);
  }
  static kbr(this$0, $base, $maxSize, $box) {
    if ($box === VOID)
      $box = {};
    $box.hbr_1 = this$0;
    $box.ibr_1 = $base;
    $box.jbr_1 = $maxSize;
    return this.mb8($box);
  }
  toString() {
    return 'CatalogVfs@' + this.hbr_1.mbr_1.toString() + ':' + toString(this.ibr_1);
  }
  *nb8(position, buffer, offset, len, $completion) {
    var tmp0 = fromInt(len);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = subtract(this.jbr_1._v, position);
    var tmp$ret$0 = compare(tmp0, b) <= 0 ? tmp0 : b;
    var rlen = convertToInt(tmp$ret$0);
    return yield* this.ibr_1.nb8(position, buffer, offset, rlen, $completion);
  }
  *ob8(position, buffer, offset, len, $completion) {
    yield* this.ibr_1.ob8(position, buffer, offset, len, $completion);
    var tmp0 = this.jbr_1._v;
    // Inline function 'kotlin.Long.plus' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = add(position, fromInt(len));
    var tmp$ret$1 = compare(tmp0, b) >= 0 ? tmp0 : b;
    this.jbr_1._v = tmp$ret$1;
    return Unit_instance;
  }
  *pb8($completion) {
    return this.jbr_1._v;
  }
  *lb6($completion) {
    return yield* this.ibr_1.lb6($completion);
  }
}
class CatalogVfs extends Proxy {
  constructor(parent) {
    super();
    this.mbr_1 = parent;
    this.nbr_1 = new Long(2097152, 0);
    this.obr_1 = Companion_getInstance_0().pb5('CatalogVfs');
    this.pbr_1 = LinkedHashMap.m7();
    this.qbr_1 = FastStringMap();
  }
  *ybf(path, range, $completion) {
    return yield* protoOf(Proxy).ybf.call(this, path, range, $completion);
  }
  *wbf(path, mode, $completion) {
    var fstat = yield* this.rbr(path, $completion);
    if (!(fstat == null) && mode.equals(VfsOpenMode_READ_getInstance()) && compare(fstat.gbg_1, this.nbr_1) <= 0) {
      return openAsync(yield* this.ybf(path, get_LONG_ZERO_TO_MAX_RANGE(), $completion));
    }
    var tmp = new VfsCachedStatContext(fstat);
    var base = yield* withContext(tmp, CatalogVfs$open$slambda(this, path, mode), $completion);
    var tmp_0;
    if ((fstat == null ? null : fstat.ebg_1) === true) {
      tmp_0 = fstat.gbg_1;
    } else {
      tmp_0 = yield* base.pb8($completion);
    }
    var maxSize = {_v: tmp_0};
    return buffered(toAsyncStream(CatalogVfs$open$2.kbr(this, base, maxSize)));
  }
  *ubf(path, $completion) {
    return this.mbr_1.wi(path);
  }
  *abg(path, $completion) {
    var tmp0_elvis_lhs = yield* this.rbr(path, $completion);
    return tmp0_elvis_lhs == null ? this.abh(normalize(_PathInfo___init__impl__vpw96a(path)), VOID, true) : tmp0_elvis_lhs;
  }
  *rbr(path, $completion) {
    var normalizedPath = normalize(_PathInfo___init__impl__vpw96a(path));
    if (normalizedPath === '/' || normalizedPath === '') {
      return this.ybg('/', true, new Long(0, 0), VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
    }
    var baseName = get_baseName(_PathInfo___init__impl__vpw96a(normalizedPath));
    var tmp0_elvis_lhs = yield* this.sbr(_PathInfo___get_fullPath__impl__21fx6x(get_parent(_PathInfo___init__impl__vpw96a(normalizedPath))), $completion);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.getOrPut' call
      var this_0 = this.pbr_1;
      var value = this_0.w4(path);
      var tmp_0;
      if (value == null) {
        var answer = yield* this.mbr_1.wi(path).bbg($completion);
        this_0.b5(path, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      return tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    var tmp1_elvis_lhs = info.w4(baseName);
    return tmp1_elvis_lhs == null ? this.abh(normalizedPath, VOID, true) : tmp1_elvis_lhs;
  }
  *sbr(path, $completion) {
    var key = normalize(_PathInfo___init__impl__vpw96a(path));
    var tmp0 = this.qbr_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = tmp0.get(key);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      var out = yield* this.tbr(key, $completion);
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp0.set(key, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  *tbr(path, $completion) {
    var tmp;
    try {
      tmp = yield* this.mbr_1.wi(path).wi('$catalog.json').tbh(VOID, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (!(e instanceof FileNotFoundException)) {
          // Inline function 'korlibs.logger.Logger.error' call
          var tmp0 = this.obr_1;
          // Inline function 'korlibs.logger.Logger.log' call
          var level = Level_ERROR_getInstance();
          if (tmp0.obj(level)) {
            tmp0.pbj(level, e);
          }
        }
        return null;
      } else {
        throw $p;
      }
    }
    var catalogJsonString = tmp;
    var data = get_dyn(Companion_getInstance_1().gx(catalogJsonString));
    var tmp24_subject = _Dyn___get_value__impl__bemnlg(data);
    if (!(tmp24_subject == null) ? isInterface(tmp24_subject, KtList) : false) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = _Dyn___get_list__impl__qpwjp(data);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.p1();
      while (_iterator__ex2g4s.q1()) {
        var item = _iterator__ex2g4s.r1();
        var it = item.qbq_1;
        var localName = get_baseName(_PathInfo___init__impl__vpw96a(_Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80_0(it, 'name'))));
        var tmp$ret$5 = this.ybg(path + '/' + localName, _Dyn___get_bool__impl__nv3iun(Dyn__get_impl_6l2p80_0(it, 'isDirectory')), _Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(it, 'size')), VOID, VOID, VOID, VOID, VOID, Companion_getInstance_2().w9v(_Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(it, 'createTime'))), Companion_getInstance_2().w9v(_Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(it, 'modifiedTime'))), VOID, VOID, VOID, true);
        destination.d2(tmp$ret$5);
      }
      // Inline function 'kotlin.collections.associateBy' call
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_0 = LinkedHashMap.cd(capacity);
      var _iterator__ex2g4s_0 = destination.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element = _iterator__ex2g4s_0.r1();
        var tmp$ret$8 = get_baseName_0(element);
        destination_0.b5(tmp$ret$8, element);
      }
      return destination_0;
    } else {
      var out = LinkedHashMap.m7();
      var _iterator__ex2g4s_1 = _Dyn___get_keys__impl__o4xmor(data).p1();
      while (_iterator__ex2g4s_1.q1()) {
        var key = _iterator__ex2g4s_1.r1().qbq_1;
        var fileName = _Dyn___get_str__impl__dup4cs(key);
        var info = Dyn__get_impl_6l2p80(data, key);
        var tmp0_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 0));
        var size = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 1));
        var creationTime = tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 2));
        var modifiedTime = tmp2_elvis_lhs == null ? creationTime : tmp2_elvis_lhs;
        var isDirectory = endsWith(fileName, '/');
        var baseName = trimEnd(fileName, charArrayOf([_Char___init__impl__6a9atx(47)]));
        // Inline function 'kotlin.collections.set' call
        var value = this.ybg(path + '/' + baseName, isDirectory, size, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_2().w9v(creationTime), Companion_getInstance_2().w9v(modifiedTime), VOID, VOID, VOID, true);
        out.b5(baseName, value);
      }
      return out;
    }
  }
}
class StandardVfs {
  ubr() {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.ybr_1 = function_0;
  }
  pj(a, b) {
    return this.ybr_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.ybr_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class MountableVfs extends Proxy {
  constructor(closeMounts) {
    super();
    this.wbr_1 = closeMounts;
    this.xbr_1 = ArrayList.p2();
  }
  *lb6($completion) {
    if (this.wbr_1) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.xbr_1;
      var n = 0;
      while (n < this_0.s2()) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        yield* this_0.u2(_unary__edvuaz).qm_1.lbf_1.lb6($completion);
      }
    }
    return Unit_instance;
  }
  zbr(folder, file) {
    // Inline function 'kotlin.apply' call
    unmountInternal(this, folder);
    var tmp0 = this.xbr_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = to(normalize(get_pathInfo(folder)), file);
    tmp0.d2(element);
    resort(this);
    return this;
  }
  *ubf(path, $completion) {
    var rpath = normalize(get_pathInfo(path));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.xbr_1;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var destruct = this_0.u2(_unary__edvuaz);
      var base = destruct.jm();
      var file = destruct.km();
      if (startsWith(rpath, base))
        return file.wi(substring(rpath, base.length));
    }
    throw FileNotFoundException.pb1(path);
  }
  toString() {
    return 'MountableVfs';
  }
}
class StandardPathsBase {}
function appPreferencesFolder(appId) {
  return Companion_getInstance().sb0() ? '/Users/' + Companion_instance_0.wi('USER') + '/Library/Preferences/' + appId : Companion_getInstance().qb0() ? '' + Companion_instance_0.wi('APPDATA') + '/' + appId : '' + Companion_instance_0.wi('HOME') + '/.config/' + appId;
}
class FinalUrlVfs$open$2 extends AsyncStreamBase {
  constructor(this$0, $path, $mode, $fullUrl, $stat) {
    return new.target.wbt(this$0, $path, $mode, $fullUrl, $stat);
  }
  static wbt(this$0, $path, $mode, $fullUrl, $stat, $box) {
    if ($box === VOID)
      $box = {};
    $box.rbt_1 = this$0;
    $box.sbt_1 = $path;
    $box.tbt_1 = $mode;
    $box.ubt_1 = $fullUrl;
    $box.vbt_1 = $stat;
    return this.mb8($box);
  }
  toString() {
    return 'UrlVfs:' + this.rbt_1.bbi_1 + ':' + this.sbt_1 + ':' + this.tbt_1.toString();
  }
  *nb8(position, buffer, offset, len, $completion) {
    if (len === 0)
      return 0;
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = add(position, fromInt(len));
    var res = yield* /*#__NOINLINE__*/_readRangeBase(this.rbt_1, this.ubt_1, until(position, tmp$ret$0), $completion);
    var s = res.nbt_1;
    var coffset = offset;
    var pending = len;
    var totalRead = 0;
    $l$loop: while (pending > 0) {
      var read = yield* s.kb6(buffer, coffset, pending, $completion);
      if (read < 0 && totalRead === 0)
        return read;
      if (read <= 0)
        break $l$loop;
      pending = pending - read | 0;
      totalRead = totalRead + read | 0;
      coffset = coffset + read | 0;
    }
    return totalRead;
  }
  *qb8($completion) {
    return compare(this.vbt_1.gbg_1, new Long(0, 0)) >= 0;
  }
  *pb8($completion) {
    var tmp;
    if (yield* this.qb8($completion)) {
      tmp = this.vbt_1.gbg_1;
    } else {
      unsupported();
    }
    return tmp;
  }
}
class FinalUrlVfs extends UrlVfs {
  constructor(url, dummy, client, failFromStatus) {
    client = client === VOID ? createHttpClient() : client;
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    super(url, dummy, failFromStatus);
    this.sbs_1 = dummy;
    this.tbs_1 = client;
    this.ubs_1 = url;
  }
  ubg() {
    return this.ubs_1;
  }
  *wbf(path, mode, $completion) {
    try {
      var fullUrl = this.ebi(path);
      if (startsWith(fullUrl, 'file:')) {
        return openAsync(yield* this.tbs_1.xbt(fullUrl, VOID, $completion));
      }
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp34_safe_receiver = $completion.od().ae(Companion_instance_1);
      var tmp0_elvis_lhs = tmp34_safe_receiver == null ? null : tmp34_safe_receiver.mbh_1;
      var stat = tmp0_elvis_lhs == null ? (yield* this.abg(path, $completion)) : tmp0_elvis_lhs;
      var tmp = stat.pbg_1;
      var response = tmp instanceof Response ? tmp : null;
      if (!stat.ebg_1) {
        throw FileNotFoundException.pb1('Unexistant ' + fullUrl + ' : ' + toString_0(response));
      }
      return buffered(toAsyncStream(FinalUrlVfs$open$2.wbt(this, path, mode, fullUrl, stat)));
    } catch ($p) {
      if ($p instanceof RuntimeException) {
        var e = $p;
        var tmp1_elvis_lhs = e.message;
        throw FileNotFoundException.pb1(tmp1_elvis_lhs == null ? 'error' : tmp1_elvis_lhs);
      } else {
        throw $p;
      }
    }
  }
  *ybf(path, range, $completion) {
    return yield* readAll((yield* /*#__NOINLINE__*/_readRangeBase(this, this.ebi(path), range, $completion)).nbt_1, $completion);
  }
  *abg(path, $completion) {
    var fullUrl = this.ebi(path);
    var tmp;
    if (startsWith(fullUrl, 'file:')) {
      var tmp_0;
      try {
        var size = fromInt((yield* this.tbs_1.xbt(fullUrl, VOID, $completion)).length);
        tmp_0 = this.ybg(path, false, size, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
          tmp_1 = this.abh(path);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      var result = yield* this.tbs_1.ibt(Companion_getInstance_6().xbs_1, fullUrl, VOID, VOID, VOID, $completion);
      var tmp_2;
      if (result.obt_1) {
        var tmp36_safe_receiver = result.lbt_1.wi(Companion_instance_5.ybt_1);
        var tmp0_elvis_lhs = tmp36_safe_receiver == null ? null : toLongOrNull(tmp36_safe_receiver);
        tmp_2 = this.ybg(path, false, tmp0_elvis_lhs == null ? new Long(-1, -1) : tmp0_elvis_lhs, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, result);
      } else {
        tmp_2 = this.abh(path, result);
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  toString() {
    return 'UrlVfs';
  }
}
class Companion {
  constructor() {
    Companion_instance_2 = this;
    this.abu_1 = 0;
    this.bbu_1 = Regex.hi('^([a-zA-Z0-9+.-]+)(?::([a-zA-Z]+))?:');
  }
  cbu(scheme) {
    switch (scheme) {
      case 'ftp':
        return 21;
      case 'ftps':
        return 990;
      case 'http':
      case 'ws':
        return 80;
      case 'https':
      case 'wss':
        return 443;
      default:
        return -1;
    }
  }
  dbu(scheme, subScheme, userInfo, host, path, query, fragment, opaque, port) {
    var tmp;
    if (scheme == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = scheme.toLowerCase();
    }
    var tmp_0 = tmp;
    var tmp_1;
    if (subScheme == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = subScheme.toLowerCase();
    }
    return new URL_0(opaque, tmp_0, tmp_1, userInfo, host, path, query, fragment, port);
  }
  ebu(scheme, subScheme, userInfo, host, path, query, fragment, opaque, port, $super) {
    scheme = scheme === VOID ? null : scheme;
    subScheme = subScheme === VOID ? null : subScheme;
    userInfo = userInfo === VOID ? null : userInfo;
    host = host === VOID ? null : host;
    path = path === VOID ? '' : path;
    query = query === VOID ? null : query;
    fragment = fragment === VOID ? null : fragment;
    opaque = opaque === VOID ? false : opaque;
    port = port === VOID ? this.abu_1 : port;
    return $super === VOID ? this.dbu(scheme, subScheme, userInfo, host, path, query, fragment, opaque, port) : $super.dbu.call(this, scheme, subScheme, userInfo, host, path, query, fragment, opaque, port);
  }
  pb5(url) {
    var r = new StrReader(url);
    var schemeColon = r.kbu(this.bbu_1);
    var tmp;
    if (!(schemeColon == null)) {
      var isHierarchical = !(r.lbu('//') == null);
      var nonScheme = r.mbu();
      var schemeParts = split(dropLast(schemeColon, 1), [':']);
      var scheme = schemeParts.u2(0);
      var subScheme = getOrNull(schemeParts, 1);
      var nonFragment = substringBefore(nonScheme, _Char___init__impl__6a9atx(35));
      var fragment = substringAfterOrNull(nonScheme, _Char___init__impl__6a9atx(35));
      var nonQuery = substringBefore(nonFragment, _Char___init__impl__6a9atx(63));
      var query = substringAfterOrNull(nonFragment, _Char___init__impl__6a9atx(63));
      var authority = substringBefore(nonQuery, _Char___init__impl__6a9atx(47));
      var path = substringAfterOrNull(nonQuery, _Char___init__impl__6a9atx(47));
      var hostWithPort = substringAfter(authority, _Char___init__impl__6a9atx(64));
      var userInfo = substringBeforeOrNull(authority, _Char___init__impl__6a9atx(64));
      var host = substringBefore(hostWithPort, _Char___init__impl__6a9atx(58));
      var port = substringAfterOrNull(hostWithPort, _Char___init__impl__6a9atx(58));
      var tmp49_opaque = !isHierarchical;
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(host) > 0) {
        tmp_0 = host;
      } else {
        tmp_0 = null;
      }
      var tmp50_host = tmp_0;
      var tmp51_path = !(path == null) ? '/' + path : '';
      var tmp0_elvis_lhs = port == null ? null : toIntOrNull(port);
      var tmp52_port = tmp0_elvis_lhs == null ? this.abu_1 : tmp0_elvis_lhs;
      tmp = this.dbu(scheme, subScheme, userInfo, tmp50_host, tmp51_path, query, fragment, tmp49_opaque, tmp52_port);
    } else {
      var nonFragment_0 = substringBefore(url, _Char___init__impl__6a9atx(35));
      var fragment_0 = substringAfterOrNull(url, _Char___init__impl__6a9atx(35));
      var path_0 = substringBefore(nonFragment_0, _Char___init__impl__6a9atx(63));
      var query_0 = substringAfterOrNull(nonFragment_0, _Char___init__impl__6a9atx(63));
      tmp = this.ebu(null, null, null, null, path_0, query_0, fragment_0, false);
    }
    return tmp;
  }
  nbu(url) {
    return !((new StrReader(url)).kbu(this.bbu_1) == null);
  }
  obu(base, access) {
    var refinedAccess = startsWith(access, '//') && contains(base, ':') ? substringBefore_0(base, ':') + ':' + access : access;
    if (this.nbu(refinedAccess))
      return refinedAccess;
    if (isBlank(base)) {
      throw MalformedInputException.laz('The base URL should not be empty, or the access URL must be absolute.');
    }
    if (!this.nbu(base)) {
      throw MalformedInputException.laz('At least one of the base URL or access URL must be absolute.');
    }
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(refinedAccess) === 0) {
      tmp = base;
    } else {
      if (startsWith(refinedAccess, '/')) {
        tmp = Companion_getInstance_5().pb5(base).nbs(VOID, VOID, VOID, VOID, VOID, normalizeUrl(refinedAccess), null).obs();
      } else {
        // Inline function 'kotlin.run' call
        var $this$run = Companion_getInstance_5().pb5(base);
        var tmp_0;
        if (startsWith(refinedAccess, '?') || startsWith(refinedAccess, '#')) {
          tmp_0 = $this$run.gbs_1 + refinedAccess;
        } else {
          tmp_0 = substringBeforeLast($this$run.gbs_1, _Char___init__impl__6a9atx(47)) + '/' + refinedAccess;
        }
        var refinedPath = tmp_0;
        tmp = $this$run.nbs(VOID, VOID, VOID, VOID, VOID, '/' + trimStart(normalizeUrl(refinedPath), charArrayOf([_Char___init__impl__6a9atx(47)])), null).obs();
      }
    }
    return tmp;
  }
}
class URL_0 {
  constructor(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) {
    Companion_getInstance_5();
    this.bbs_1 = isOpaque;
    this.cbs_1 = scheme;
    this.dbs_1 = subScheme;
    this.ebs_1 = userInfo;
    this.fbs_1 = host;
    this.gbs_1 = path;
    this.hbs_1 = query;
    this.ibs_1 = fragment;
    this.jbs_1 = defaultPort;
    var tmp = this;
    tmp.kbs_1 = lazy(URL$fullUrl$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.lbs_1 = lazy(URL$fullUrlWithoutScheme$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.mbs_1 = lazy(URL$pathWithQuery$delegate$lambda(this));
  }
  qbu() {
    return this.cbs_1 === 'https' || this.cbs_1 === 'wss' || this.cbs_1 === 'ftps';
  }
  rbu() {
    return Companion_getInstance_5().cbu(this.cbs_1);
  }
  h7v() {
    return this.jbs_1 === Companion_getInstance_5().abu_1 ? this.rbu() : this.jbs_1;
  }
  obs() {
    var tmp0 = this.kbs_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('fullUrl', 1, tmp, URL$_get_fullUrl_$ref_2cgnp1(), null);
    return tmp0.k3();
  }
  sbu(includeScheme, out) {
    if (includeScheme && !(this.cbs_1 == null)) {
      out.m1('' + this.cbs_1 + ':');
      if (!(this.dbs_1 == null)) {
        out.m1('' + this.dbs_1 + ':');
      }
      if (!this.bbs_1) {
        out.m1('//');
      }
    }
    if (!(this.ebs_1 == null)) {
      out.m1('' + this.ebs_1 + '@');
    }
    if (!(this.fbs_1 == null)) {
      out.m1(this.fbs_1);
    }
    if (!(this.h7v() === Companion_getInstance_5().abu_1) && !(this.h7v() === this.rbu())) {
      out.o1(_Char___init__impl__6a9atx(58)).kh(this.h7v());
    }
    out.m1(this.gbs_1);
    if (!(this.hbs_1 == null)) {
      out.m1('?' + this.hbs_1);
    }
    if (!(this.ibs_1 == null)) {
      out.m1('#' + this.ibs_1);
    }
    return out;
  }
  pbu(includeScheme, out, $super) {
    includeScheme = includeScheme === VOID ? true : includeScheme;
    out = out === VOID ? StringBuilder.l1() : out;
    return $super === VOID ? this.sbu(includeScheme, out) : $super.sbu.call(this, includeScheme, out);
  }
  toString() {
    return this.obs();
  }
  tbu(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) {
    return new URL_0(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort);
  }
  nbs(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort, $super) {
    isOpaque = isOpaque === VOID ? this.bbs_1 : isOpaque;
    scheme = scheme === VOID ? this.cbs_1 : scheme;
    subScheme = subScheme === VOID ? this.dbs_1 : subScheme;
    userInfo = userInfo === VOID ? this.ebs_1 : userInfo;
    host = host === VOID ? this.fbs_1 : host;
    path = path === VOID ? this.gbs_1 : path;
    query = query === VOID ? this.hbs_1 : query;
    fragment = fragment === VOID ? this.ibs_1 : fragment;
    defaultPort = defaultPort === VOID ? this.jbs_1 : defaultPort;
    return $super === VOID ? this.tbu(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) : $super.tbu.call(this, isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort);
  }
  hashCode() {
    var result = getBooleanHashCode(this.bbs_1);
    result = imul(result, 31) + (this.cbs_1 == null ? 0 : getStringHashCode(this.cbs_1)) | 0;
    result = imul(result, 31) + (this.dbs_1 == null ? 0 : getStringHashCode(this.dbs_1)) | 0;
    result = imul(result, 31) + (this.ebs_1 == null ? 0 : getStringHashCode(this.ebs_1)) | 0;
    result = imul(result, 31) + (this.fbs_1 == null ? 0 : getStringHashCode(this.fbs_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.gbs_1) | 0;
    result = imul(result, 31) + (this.hbs_1 == null ? 0 : getStringHashCode(this.hbs_1)) | 0;
    result = imul(result, 31) + (this.ibs_1 == null ? 0 : getStringHashCode(this.ibs_1)) | 0;
    result = imul(result, 31) + this.jbs_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof URL_0))
      return false;
    var tmp0_other_with_cast = other instanceof URL_0 ? other : THROW_CCE();
    if (!(this.bbs_1 === tmp0_other_with_cast.bbs_1))
      return false;
    if (!(this.cbs_1 == tmp0_other_with_cast.cbs_1))
      return false;
    if (!(this.dbs_1 == tmp0_other_with_cast.dbs_1))
      return false;
    if (!(this.ebs_1 == tmp0_other_with_cast.ebs_1))
      return false;
    if (!(this.fbs_1 == tmp0_other_with_cast.fbs_1))
      return false;
    if (!(this.gbs_1 === tmp0_other_with_cast.gbs_1))
      return false;
    if (!(this.hbs_1 == tmp0_other_with_cast.hbs_1))
      return false;
    if (!(this.ibs_1 == tmp0_other_with_cast.ibs_1))
      return false;
    if (!(this.jbs_1 === tmp0_other_with_cast.jbs_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_3 = this;
    this.vbs_1 = Methods_OPTIONS_getInstance();
    this.wbs_1 = Methods_GET_getInstance();
    this.xbs_1 = Methods_HEAD_getInstance();
    this.ybs_1 = Methods_POST_getInstance();
    this.zbs_1 = Methods_PUT_getInstance();
    this.abt_1 = Methods_DELETE_getInstance();
    this.bbt_1 = Methods_TRACE_getInstance();
    this.cbt_1 = Methods_CONNECT_getInstance();
    this.dbt_1 = Methods_PATCH_getInstance();
    this.ebt_1 = listOf([this.vbs_1, this.wbs_1, this.xbs_1, this.ybs_1, this.zbs_1, this.abt_1, this.bbt_1, this.cbt_1, this.dbt_1]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.ebt_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = to(item.v1_1, item);
      destination.d2(tmp$ret$2);
    }
    tmp.fbt_1 = toMap(destination);
  }
}
class Companion_1 {}
class Companion_2 {
  constructor() {
    this.ybt_1 = 'Content-Length';
    this.zbt_1 = 'Content-Type';
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.ubu_1 = function_0;
  }
  pj(a, b) {
    return this.ubu_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.ubu_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class Methods extends Enum {}
class HttpException extends IOException {
  constructor(statusCode, msg, statusText, headers) {
    return new.target.cbv(statusCode, msg, statusText, headers);
  }
  static cbv(statusCode, msg, statusText, headers) {
    msg = msg === VOID ? 'Error' + statusCode : msg;
    var tmp;
    if (statusText === VOID) {
      var tmp0_elvis_lhs = HttpStatusMessage_getInstance().dbv_1.w4(statusCode);
      tmp = tmp0_elvis_lhs == null ? 'Error' + statusCode : tmp0_elvis_lhs;
    } else {
      tmp = statusText;
    }
    statusText = tmp;
    headers = headers === VOID ? Headers.ebv([]) : headers;
    var $this = this.sb1('' + statusCode + ' ' + statusText + ' - ' + msg);
    captureStack($this, $this.bbv_1);
    $this.xbu_1 = statusCode;
    $this.ybu_1 = msg;
    $this.zbu_1 = statusText;
    $this.abv_1 = headers;
    return $this;
  }
}
class Headers {
  constructor(items) {
    return new.target.fbv(items);
  }
  static fbv(items) {
    var $this = createThis(this);
    $this.gbt_1 = items;
    return $this;
  }
  static ebv(items) {
    return this.fbv(toList(items));
  }
  static hbt(map) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(map.s2());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = map.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$3 = to(item.j3(), item.k3());
      destination.d2(tmp$ret$3);
    }
    return this.fbv(destination);
  }
  p1() {
    return this.gbt_1.p1();
  }
  wi(key) {
    return this.gbv(key);
  }
  gbv(key) {
    var tmp0 = this.gbt_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (equals_0(element.pm_1, key, true)) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var tmp56_safe_receiver = tmp$ret$0;
    return tmp56_safe_receiver == null ? null : tmp56_safe_receiver.qm_1;
  }
  hbv() {
    // Inline function 'kotlin.collections.groupBy' call
    var tmp0 = this.gbt_1;
    // Inline function 'kotlin.collections.groupByTo' call
    var destination = LinkedHashMap.m7();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var key = element.pm_1.toLowerCase();
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.w4(key);
      var tmp;
      if (value == null) {
        var answer = ArrayList.p2();
        destination.b5(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.d2(element);
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(destination.s2());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = destination.i3().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp_0 = first(item.k3()).pm_1;
      // Inline function 'kotlin.collections.map' call
      var this_0 = item.k3();
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s_1 = this_0.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var item_0 = _iterator__ex2g4s_1.r1();
        var tmp$ret$13 = item_0.qm_1;
        destination_1.d2(tmp$ret$13);
      }
      var tmp$ret$10 = to(tmp_0, destination_1);
      destination_0.d2(tmp$ret$10);
    }
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = Http$Headers$toListGrouped$lambda;
    var tmp$ret$15 = new sam$kotlin_Comparator$0_0(tmp_1);
    return sortedWith(destination_0, tmp$ret$15);
  }
  ibv(newHeaders) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(newHeaders, 10));
    var _iterator__ex2g4s = newHeaders.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = item.pm_1.toLowerCase();
      destination.d2(tmp$ret$2);
    }
    var replaceKeys = toSet(destination);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.gbt_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList.p2();
    var _iterator__ex2g4s_0 = tmp0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element = _iterator__ex2g4s_0.r1();
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$8 = element.pm_1.toLowerCase();
      if (!replaceKeys.w2(tmp$ret$8)) {
        destination_0.d2(element);
      }
    }
    return Headers.fbv(plus(destination_0, toList_0(newHeaders)));
  }
  jbv(newHeaders) {
    return this.ibv(toList(newHeaders));
  }
  kbv(newHeaders) {
    return this.ibv(toList_0(newHeaders));
  }
  toString() {
    return 'Headers(' + joinToString(this.hbv(), ', ') + ')';
  }
  hashCode() {
    return hashCode(this.gbt_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Headers))
      return false;
    var tmp0_other_with_cast = other instanceof Headers ? other : THROW_CCE();
    if (!equals(this.gbt_1, tmp0_other_with_cast.gbt_1))
      return false;
    return true;
  }
}
class Companion_3 {
  *lbv(status, statusText, headers, rawContent, $completion) {
    var tmp0_elvis_lhs = headers.wi('Transfer-Encoding');
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.text.trim' call
    var this_0 = (tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs).toLowerCase();
    var transferEncoding = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    var tmp1_elvis_lhs = headers.wi('Content-Encoding');
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.text.trim' call
    var this_1 = (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs).toLowerCase();
    var contentEncoding = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
    return new Response(status, statusText, headers, rawContent, yield* withContentEncoding(yield* withTransferEncoding(rawContent, transferEncoding, $completion), contentEncoding, $completion));
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_7 = this;
    this.nbv_1 = new RequestConfig();
  }
}
class Response {
  constructor(status, statusText, headers, rawContent, content) {
    this.jbt_1 = status;
    this.kbt_1 = statusText;
    this.lbt_1 = headers;
    this.mbt_1 = rawContent;
    this.nbt_1 = content;
    this.obt_1 = this.jbt_1 < 400;
    var tmp = this;
    tmp.pbt_1 = lazy(HttpClient$Response$responseCharset$delegate$lambda);
  }
  *obv($completion) {
    var allContent = yield* readAll(this.nbt_1, $completion);
    return allContent;
  }
  mbv() {
    var tmp0 = this.pbt_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('responseCharset', 1, tmp, HttpClient$Response$_get_responseCharset_$ref_osz7el(), null);
    return tmp0.k3();
  }
  *pbv(charset, $completion) {
    var bytes = yield* this.obv($completion);
    return toString_2(bytes, charset);
  }
  qbv(charset, $completion, $super) {
    charset = charset === VOID ? this.mbv() : charset;
    return $super === VOID ? this.pbv(charset, $completion) : $super.pbv.call(this, charset, $completion);
  }
  *qbt($completion) {
    // Inline function 'kotlin.apply' call
    if (!this.obt_1)
      throw HttpException.cbv(this.jbt_1, yield* this.qbv(VOID, $completion), this.kbt_1);
    return this;
  }
  rbv(content) {
    return new CompletedResponse(this.jbt_1, this.kbt_1, this.lbt_1, content);
  }
  toString() {
    return 'Response(status=' + this.jbt_1 + ', statusText=' + this.kbt_1 + ', headers=' + this.lbt_1.toString() + ', rawContent=' + toString(this.mbt_1) + ', content=' + toString(this.nbt_1) + ')';
  }
  hashCode() {
    var result = this.jbt_1;
    result = imul(result, 31) + getStringHashCode(this.kbt_1) | 0;
    result = imul(result, 31) + this.lbt_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.mbt_1) | 0;
    result = imul(result, 31) + hashCode(this.nbt_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Response))
      return false;
    var tmp0_other_with_cast = other instanceof Response ? other : THROW_CCE();
    if (!(this.jbt_1 === tmp0_other_with_cast.jbt_1))
      return false;
    if (!(this.kbt_1 === tmp0_other_with_cast.kbt_1))
      return false;
    if (!this.lbt_1.equals(tmp0_other_with_cast.lbt_1))
      return false;
    if (!equals(this.mbt_1, tmp0_other_with_cast.mbt_1))
      return false;
    if (!equals(this.nbt_1, tmp0_other_with_cast.nbt_1))
      return false;
    return true;
  }
}
class CompletedResponse {
  constructor(status, statusText, headers, content) {
    this.sbv_1 = status;
    this.tbv_1 = statusText;
    this.ubv_1 = headers;
    this.vbv_1 = content;
    this.wbv_1 = this.sbv_1 < 400;
  }
  toString() {
    return 'CompletedResponse(status=' + this.sbv_1 + ', statusText=' + this.tbv_1 + ', headers=' + this.ubv_1.toString() + ', content=' + toString_0(this.vbv_1) + ')';
  }
  hashCode() {
    var result = this.sbv_1;
    result = imul(result, 31) + getStringHashCode(this.tbv_1) | 0;
    result = imul(result, 31) + this.ubv_1.hashCode() | 0;
    result = imul(result, 31) + (this.vbv_1 == null ? 0 : hashCode(this.vbv_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedResponse))
      return false;
    var tmp0_other_with_cast = other instanceof CompletedResponse ? other : THROW_CCE();
    if (!(this.sbv_1 === tmp0_other_with_cast.sbv_1))
      return false;
    if (!(this.tbv_1 === tmp0_other_with_cast.tbv_1))
      return false;
    if (!this.ubv_1.equals(tmp0_other_with_cast.ubv_1))
      return false;
    if (!equals(this.vbv_1, tmp0_other_with_cast.vbv_1))
      return false;
    return true;
  }
}
class RequestConfig {
  constructor(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    Companion_getInstance_10();
    followRedirects = followRedirects === VOID ? true : followRedirects;
    throwErrors = throwErrors === VOID ? false : throwErrors;
    maxRedirects = maxRedirects === VOID ? 10 : maxRedirects;
    referer = referer === VOID ? null : referer;
    simulateBrowser = simulateBrowser === VOID ? false : simulateBrowser;
    this.xbv_1 = followRedirects;
    this.ybv_1 = throwErrors;
    this.zbv_1 = maxRedirects;
    this.abw_1 = referer;
    this.bbw_1 = simulateBrowser;
  }
  cbw(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    return new RequestConfig(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  }
  dbw(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $super) {
    followRedirects = followRedirects === VOID ? this.xbv_1 : followRedirects;
    throwErrors = throwErrors === VOID ? this.ybv_1 : throwErrors;
    maxRedirects = maxRedirects === VOID ? this.zbv_1 : maxRedirects;
    referer = referer === VOID ? this.abw_1 : referer;
    simulateBrowser = simulateBrowser === VOID ? this.bbw_1 : simulateBrowser;
    return $super === VOID ? this.cbw(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) : $super.cbw.call(this, followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  }
  toString() {
    return 'RequestConfig(followRedirects=' + this.xbv_1 + ', throwErrors=' + this.ybv_1 + ', maxRedirects=' + this.zbv_1 + ', referer=' + this.abw_1 + ', simulateBrowser=' + this.bbw_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.xbv_1);
    result = imul(result, 31) + getBooleanHashCode(this.ybv_1) | 0;
    result = imul(result, 31) + this.zbv_1 | 0;
    result = imul(result, 31) + (this.abw_1 == null ? 0 : getStringHashCode(this.abw_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.bbw_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestConfig))
      return false;
    var tmp0_other_with_cast = other instanceof RequestConfig ? other : THROW_CCE();
    if (!(this.xbv_1 === tmp0_other_with_cast.xbv_1))
      return false;
    if (!(this.ybv_1 === tmp0_other_with_cast.ybv_1))
      return false;
    if (!(this.zbv_1 === tmp0_other_with_cast.zbv_1))
      return false;
    if (!(this.abw_1 == tmp0_other_with_cast.abw_1))
      return false;
    if (!(this.bbw_1 === tmp0_other_with_cast.bbw_1))
      return false;
    return true;
  }
}
class HttpClient {}
function *request(method, url, headers, content, config, $completion) {
  var tmp0_elvis_lhs = content == null ? null : (yield* content.pb8($completion));
  var contentLength = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
  var actualHeaders = headers;
  var tmp;
  if (!(content == null)) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(headers, Collection)) {
        tmp_0 = headers.n1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = headers.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (equals_0(element.pm_1, Companion_instance_5.ybt_1, true)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp = !tmp$ret$0;
  } else {
    tmp = false;
  }
  if (tmp) {
    actualHeaders = actualHeaders.jbv([to(Companion_instance_5.ybt_1, contentLength.toString())]);
  }
  if (config.bbw_1) {
    actualHeaders = Companion_getInstance_11().pbw(actualHeaders, null);
  }
  // Inline function 'kotlin.apply' call
  var this_0 = yield* this.kbw(method, url, actualHeaders, content, $completion);
  if (config.ybv_1) {
    yield* this_0.qbt($completion);
  }
  var response = this_0;
  if (config.xbv_1 && config.zbv_1 >= 0) {
    var redirectLocation = response.lbt_1.wi('location');
    if (!(redirectLocation == null)) {
      return yield* this.lbw(method, mergeUrls(this, url, redirectLocation), headers.jbv([to('Referer', url)]), content, config.dbw(VOID, VOID, config.zbv_1 - 1 | 0), $completion);
    }
  }
  return response;
}
function request$default(method, url, headers, content, config, $completion, $super) {
  headers = headers === VOID ? Headers.ebv([]) : headers;
  content = content === VOID ? null : content;
  config = config === VOID ? Companion_getInstance_10().nbv_1 : config;
  return $super === VOID ? this.lbw(method, url, headers, content, config, $completion) : /*#__NOINLINE__*/request(method, url, headers, content, config, $completion);
}
function *requestAsBytes(method, url, headers, content, config, $completion) {
  var res = yield* this.lbw(method, url, headers, content, config, $completion);
  return res.rbv(yield* res.obv($completion));
}
function requestAsBytes$default(method, url, headers, content, config, $completion, $super) {
  headers = headers === VOID ? Headers.ebv([]) : headers;
  content = content === VOID ? null : content;
  config = config === VOID ? new RequestConfig() : config;
  return $super === VOID ? this.mbw(method, url, headers, content, config, $completion) : /*#__NOINLINE__*/requestAsBytes(method, url, headers, content, config, $completion);
}
function *readBytes(url, config, $completion) {
  return (yield* this.nbw(Companion_getInstance_6().wbs_1, url, VOID, VOID, config.dbw(VOID, true), $completion)).vbv_1;
}
function readBytes$default(url, config, $completion, $super) {
  config = config === VOID ? new RequestConfig() : config;
  return $super === VOID ? this.obw(url, config, $completion) : /*#__NOINLINE__*/readBytes(url, config, $completion);
}
class Companion_5 {
  constructor() {
    Companion_instance_8 = this;
    this.ebw_1 = createHttpClientFromFetch();
    this.fbw_1 = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.81 Safari/537.36';
    this.gbw_1 = 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8';
    this.hbw_1 = 'en-us';
    this.ibw_1 = 'gzip, deflate';
    this.jbw_1 = 'Close';
  }
  *kbw(method, url, headers, content, $completion) {
    return yield* this.ebw_1.kbw(method, url, headers, content, $completion);
  }
  *lbw(method, url, headers, content, config, $completion) {
    return yield* this.ebw_1.lbw(method, url, headers, content, config, $completion);
  }
  *mbw(method, url, headers, content, config, $completion) {
    return yield* this.ebw_1.mbw(method, url, headers, content, config, $completion);
  }
  *obw(url, config, $completion) {
    return yield* this.ebw_1.obw(url, config, $completion);
  }
  pbw(headers, host) {
    var out = Headers.ebv([to('User-Agent', this.fbw_1), to('Accept', this.gbw_1), to('Accept-Language', this.hbw_1), to('Accept-Encoding', this.ibw_1), to('Connection', this.jbw_1)]).kbv(headers);
    return !(host == null) ? out.jbv([to('Host', host)]) : out;
  }
}
class HttpStatusMessage {
  constructor() {
    HttpStatusMessage_instance = this;
    this.dbv_1 = linkedMapOf([to(100, 'Continue'), to(101, 'Switching Protocols'), to(200, 'OK'), to(201, 'Created'), to(202, 'Accepted'), to(203, 'Non-Authoritative Information'), to(204, 'No Content'), to(205, 'Reset Content'), to(206, 'Partial Content'), to(300, 'Multiple Choices'), to(301, 'Moved Permanently'), to(302, 'Found'), to(303, 'See Other'), to(304, 'Not Modified'), to(305, 'Use Proxy'), to(307, 'Temporary Redirect'), to(400, 'Bad Request'), to(401, 'Unauthorized'), to(402, 'Payment Required'), to(403, 'Forbidden'), to(404, 'Not Found'), to(405, 'Method Not Allowed'), to(406, 'Not Acceptable'), to(407, 'Proxy Authentication Required'), to(408, 'Request Timeout'), to(409, 'Conflict'), to(410, 'Gone'), to(411, 'Length Required'), to(412, 'Precondition Failed'), to(413, 'Request Entity Too Large'), to(414, 'Request-URI Too Long'), to(415, 'Unsupported Media Type'), to(416, 'Requested Range Not Satisfiable'), to(417, 'Expectation Failed'), to(418, "I'm a teapot"), to(422, 'Unprocessable Entity (WebDAV - RFC 4918)'), to(423, 'Locked (WebDAV - RFC 4918)'), to(424, 'Failed Dependency (WebDAV) (RFC 4918)'), to(425, 'Unassigned'), to(426, 'Upgrade Required (RFC 7231)'), to(428, 'Precondition Required'), to(429, 'Too Many Requests'), to(431, 'Request Header Fileds Too Large)'), to(449, 'Error449'), to(451, 'Unavailable for Legal Reasons'), to(500, 'Internal Server Error'), to(501, 'Not Implemented'), to(502, 'Bad Gateway'), to(503, 'Service Unavailable'), to(504, 'Gateway Timeout'), to(505, 'HTTP Version Not Supported'), to(506, 'Variant Also Negotiates (RFC 2295)'), to(507, 'Insufficient Storage (WebDAV - RFC 4918)'), to(508, 'Loop Detected (WebDAV)'), to(509, 'Bandwidth Limit Exceeded'), to(510, 'Not Extended (RFC 2774)'), to(511, 'Network Authentication Required')]);
  }
}
class ProxiedHttpFactory {
  constructor(parent) {
    this.rbw_1 = parent;
    this.sbw_1 = parent;
  }
  qbw() {
    return this.rbw_1.qbw();
  }
}
class createHttpClientFromFetch$1 {
  constructor($fetch) {
    this.ubw_1 = $fetch;
    this.tbw_1 = false;
  }
  *kbw(method, url, headers, content, $completion) {
    var url_0 = Companion_getInstance_5().pb5(url);
    var tmp = method.h1();
    var tmp0_elvis_lhs = url_0.fbs_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Missing host';
      throw IllegalStateException.o(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var result = yield* this.ubw_1.zbq(tmp, tmp_0, url_0.h7v(), url_0.gbs_1, url_0.qbu(), toList_0(headers), content, $completion);
    return yield* Companion_instance_6.lbv(result.abr_1, result.bbr_1, Headers.fbv(result.cbr_1), result.dbr_1, $completion);
  }
}
class Resources {
  constructor(coroutineContext, root, parent) {
    root = root === VOID ? get_resourcesVfs() : root;
    parent = parent === VOID ? null : parent;
    this.vbw_1 = coroutineContext;
    this.wbw_1 = root;
    this.xbw_1 = parent;
    this.ybw_1 = LinkedHashMap.m7();
  }
}
class Text {}
class Marker {}
class Line {
  constructor(str) {
    this.abx_1 = str;
  }
  zbw() {
    return this.abx_1;
  }
  toString() {
    return 'Line(str=' + this.abx_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.abx_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line))
      return false;
    var tmp0_other_with_cast = other instanceof Line ? other : THROW_CCE();
    if (!(this.abx_1 === tmp0_other_with_cast.abx_1))
      return false;
    return true;
  }
}
class LineDeferred {}
class EmptyLineOnce {}
class Indent {}
class Unindent {}
class INDENTS {
  u2(index) {
    return INDENTS_getInstance().u2(index);
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'korlibs.io.util.Companion.gen' call
    Companion_getInstance_12();
    var indenter = new Indenter();
    tmp.bbx_1 = indenter;
  }
  cbx(init) {
    // Inline function 'korlibs.io.util.Companion.gen' call
    var indenter = new Indenter();
    init(indenter);
    return indenter;
  }
}
class IndenterEvaluator {
  constructor(markHandler, indentEmptyLines, doIndent) {
    this.dbx_1 = markHandler;
    this.ebx_1 = indentEmptyLines;
    this.fbx_1 = doIndent;
    this.gbx_1 = StringBuilder.l1();
    this.hbx_1 = 0;
    this.ibx_1 = true;
    this.jbx_1 = 0;
    this.kbx_1 = false;
  }
  lbx(str) {
    return this.gbx_1.m1(str);
  }
  mbx(str) {
    return this.gbx_1.o1(str);
  }
  nbx() {
    if (this.fbx_1) {
      this.mbx(_Char___init__impl__6a9atx(10));
    }
    this.hbx_1 = this.hbx_1 + 1 | 0;
    this.ibx_1 = true;
  }
  obx(actions) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < actions.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var action = actions.u2(_unary__edvuaz);
      if (isInterface(action, Text)) {
        if (this.ibx_1) {
          var tmp;
          if (!this.ebx_1) {
            // Inline function 'kotlin.text.isEmpty' call
            var this_0 = action.zbw();
            tmp = charSequenceLength(this_0) === 0;
          } else {
            tmp = false;
          }
          if (tmp) {
            this.nbx();
          } else {
            if (this.fbx_1)
              this.lbx(INDENTS_instance.u2(this.jbx_1));
            else
              this.lbx(' ');
          }
        }
        this.lbx(action.zbw());
        if (action instanceof Line) {
          var tmp_0 = this;
          var tmp_1 = this.hbx_1;
          // Inline function 'kotlin.text.count' call
          var count = 0;
          var indexedObject = action.abx_1;
          var inductionVariable = 0;
          while (inductionVariable < charSequenceLength(indexedObject)) {
            var element = charSequenceGet(indexedObject, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            if (element === _Char___init__impl__6a9atx(10)) {
              count = count + 1 | 0;
            }
          }
          tmp_0.hbx_1 = tmp_1 + count | 0;
          this.nbx();
        } else {
          this.ibx_1 = false;
        }
        this.kbx_1 = true;
      } else {
        if (action instanceof LineDeferred) {
          this.obx(action.tbx_1().qbx_1);
        } else {
          if (equals(action, Indent_instance) || equals(action, Unindent_instance)) {
            this.kbx_1 = false;
            this.jbx_1 = this.jbx_1 + (equals(action, Indent_instance) ? 1 : -1) | 0;
          } else {
            if (equals(action, EmptyLineOnce_instance)) {
              if (this.kbx_1) {
                this.nbx();
                this.kbx_1 = false;
              }
            } else {
              if (action instanceof Marker) {
                var tmp104_safe_receiver = this.dbx_1;
                if (tmp104_safe_receiver == null)
                  null;
                else
                  tmp104_safe_receiver(this.gbx_1, this.hbx_1, action.pbx_1);
              }
            }
          }
        }
      }
    }
  }
}
class Indenter {
  constructor(actions) {
    Companion_getInstance_12();
    var tmp;
    if (actions === VOID) {
      // Inline function 'kotlin.collections.arrayListOf' call
      tmp = ArrayList.p2();
    } else {
      tmp = actions;
    }
    actions = tmp;
    this.qbx_1 = actions;
    this.rbx_1 = true;
    this.sbx_1 = '';
  }
  ubx(indenter) {
    // Inline function 'kotlin.apply' call
    this.qbx_1.t2(indenter.qbx_1);
    return this;
  }
  vbx(str) {
    // Inline function 'kotlin.apply' call
    this.qbx_1.d2(new Line(str));
    return this;
  }
  f2h() {
    this.qbx_1.d2(Indent_instance);
  }
  wbx() {
    this.qbx_1.d2(Unindent_instance);
  }
  xbx(markHandler, doIndent) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IndenterEvaluator(markHandler, this.rbx_1, doIndent);
    this_0.obx(this.qbx_1);
    return this_0.gbx_1.toString();
  }
  toString() {
    return this.xbx(null, true);
  }
}
class Once {
  constructor() {
    this.ybx_1 = false;
  }
}
class Companion_7 {}
class BaseStrReader {
  b6y() {
    return !this.fb5();
  }
  ub5() {
    return this.bby(0);
  }
  vb5() {
    var out = this.ub5();
    this.ca1(1);
    return out;
  }
  lbu(lit, consume, $super) {
    consume = consume === VOID ? true : consume;
    return $super === VOID ? this.aby(lit, consume) : $super.aby.call(this, lit, consume);
  }
  zbx(count) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.za9(count);
    this.ca1(count);
    return this_0;
  }
}
class StrReader extends BaseStrReader {
  constructor(str, file, pos) {
    file = file === VOID ? 'file' : file;
    pos = pos === VOID ? 0 : pos;
    super();
    this.fbu_1 = str;
    this.gbu_1 = file;
    this.hbu_1 = pos;
    this.ibu_1 = charArray(this.fbu_1.length);
    this.jbu_1 = this.fbu_1.length;
  }
  wb5() {
    return this.hbu_1;
  }
  ab5() {
    return this.jbu_1 - this.hbu_1 | 0;
  }
  fb5() {
    return this.hbu_1 >= this.fbu_1.length;
  }
  za9(count) {
    return substr(this, this.hbu_1, count);
  }
  ub5() {
    return this.b6y() ? charCodeAt(this.fbu_1, this.hbu_1) : _Char___init__impl__6a9atx(0);
  }
  vb5() {
    return this.b6y() ? charCodeAt(this.fbu_1, posSkip(this, 1)) : _Char___init__impl__6a9atx(0);
  }
  mbu() {
    return this.zbx(this.ab5());
  }
  ca1(count) {
    this.hbu_1 = this.hbu_1 + count | 0;
    return this;
  }
  aby(lit, consume) {
    if (!substringEquals(StringCompanionObject_instance, this.fbu_1, this.hbu_1, lit, 0, lit.length))
      return null;
    if (consume)
      this.hbu_1 = this.hbu_1 + lit.length | 0;
    return lit;
  }
  kbu(v) {
    var tmp0_elvis_lhs = v.ji(substring(this.fbu_1, this.hbu_1));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var result = tmp;
    var m = ensureNotNull(result.vi().u2(0)).ui_1;
    this.hbu_1 = this.hbu_1 + m.length | 0;
    return m;
  }
  bby(offset) {
    var tmp0 = this.fbu_1;
    // Inline function 'kotlin.text.getOrElse' call
    var index = this.hbu_1 + offset | 0;
    var tmp;
    if (0 <= index ? index <= (charSequenceLength(tmp0) - 1 | 0) : false) {
      tmp = charSequenceGet(tmp0, index);
    } else {
      tmp = _Char___init__impl__6a9atx(0);
    }
    return tmp;
  }
}
class WorkerTask {
  constructor() {
    this.iby_1 = null;
    this.jby_1 = false;
    var tmp = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp.kby_1 = emptyList();
    this.lby_1 = null;
    this.mby_1 = false;
  }
  oby(_set____db54di) {
    this.kby_1 = _set____db54di;
  }
  pby() {
    if (!this.mby_1) {
      // Inline function 'kotlin.error' call
      var message = 'Must wrap function around runSuspend';
      throw IllegalStateException.o(toString(message));
    }
    return this.kby_1;
  }
  qby(_set____db54di) {
    this.lby_1 = _set____db54di;
  }
  rby() {
    return this.lby_1;
  }
  nby(block) {
    this.mby_1 = true;
    try {
      if (this.jby_1) {
        this.iby_1 = currentStackTrace();
        return Unit_instance;
      }
      var deferred = CompletableDeferred();
      var tmp = EmptyCoroutineContext_getInstance();
      launchImmediately(tmp, WorkerTask$runSuspend$slambda(deferred, this, block));
      this.lby_1 = deferred;
    }finally {
      this.mby_1 = false;
    }
  }
  hby() {
    return Unit_instance;
  }
  sby() {
    this.jby_1 = true;
    try {
      this.hby();
      return ensureNotNull(this.iby_1);
    }finally {
      this.jby_1 = false;
    }
  }
}
class DemoWorkerTask extends WorkerTask {
  hby() {
    return this.nby(DemoWorkerTask$execute$slambda());
  }
}
class Companion_8 {}
class _WorkerImpl {
  tby() {
    return Unit_instance;
  }
  uby() {
    return false;
  }
}
class BlobAsyncBaseStream extends AsyncStreamBase {
  constructor(blob) {
    return new.target.wby(blob);
  }
  static wby(blob) {
    var $this = this.mb8();
    $this.vby_1 = blob;
    return $this;
  }
  *lb6($completion) {
    return Unit_instance;
  }
  *nb8(position, buffer, offset, len, $completion) {
    var deferred = CompletableDeferred();
    var reader = new FileReader();
    reader.onload = BlobAsyncBaseStream$read$lambda(reader, len, buffer, offset, deferred);
    reader.onerror = BlobAsyncBaseStream$read$lambda_0(deferred, reader);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = this.vby_1;
    reader.readAsArrayBuffer(tmp$ret$0.slice(toNumber(position), toNumber(position) + len));
    return yield* deferred.m1q($completion);
  }
  *pb8($completion) {
    return numberToLong(this.vby_1.size);
  }
}
class toVfs$1 extends Vfs {
  constructor($file, $box) {
    if ($box === VOID)
      $box = {};
    $box.yby_1 = $file;
    super($box);
    this.xby_1 = $file.name;
  }
  ubg() {
    return this.xby_1;
  }
  *wbf(path, mode, $completion) {
    return openAsync_0(this.yby_1);
  }
}
class standardVfs$1 extends StandardVfs {
  constructor() {
    super();
    var tmp = this;
    tmp.cbz_1 = lazy(standardVfs$o$resourcesVfs$delegate$lambda);
    var tmp_0 = this;
    tmp_0.dbz_1 = lazy(standardVfs$o$rootLocalVfs$delegate$lambda);
  }
  ubr() {
    var tmp0 = this.cbz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('resourcesVfs', 1, tmp, standardVfs$o$_get_resourcesVfs_$ref_bvytcf(), null);
    return tmp0.k3();
  }
}
class StandardPaths {}
class httpFactory$2$1 {
  qbw() {
    return get_jsRuntime().ebz();
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_12 = this;
    this.fbz_1 = Companion_getInstance_0().pb5('JsRuntime');
  }
}
class JsRuntime {
  constructor() {
    Companion_getInstance_15();
    this.zby_1 = 'unknown';
    this.abz_1 = get_isDenoJs() ? 'deno.js' : get_isWeb() ? 'web.js' : get_isNodeJs() ? 'node.js' : get_isWorker() ? 'worker.js' : get_isShell() ? 'shell.js' : 'js';
  }
  bbz(path) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  ebz() {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
}
class JsRuntimeBrowser extends JsRuntime {
  constructor() {
    Companion_getInstance_16();
    super();
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    tmp.ibz_1 = navigator.platform;
    var tmp_0 = this;
    tmp_0.jbz_1 = lazy(JsRuntimeBrowser$href$delegate$lambda);
    var tmp_1 = this;
    tmp_1.kbz_1 = lazy(JsRuntimeBrowser$baseUrl$delegate$lambda(this));
  }
  lbz() {
    var tmp0 = this.jbz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('href', 1, tmp, JsRuntimeBrowser$_get_href_$ref_bj91mu(), null);
    return tmp0.k3();
  }
  mbz() {
    var tmp0 = this.kbz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('baseUrl', 1, tmp, JsRuntimeBrowser$_get_baseUrl_$ref_np3n1z(), null);
    return tmp0.k3();
  }
  nbz() {
    return this.mbz();
  }
  bbz(path) {
    // Inline function 'korlibs.io.file.std.withCatalogJail' call
    var this_0 = UrlVfs_2(this.nbz()).wi(path);
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_1 = (new CatalogVfs(this_0.vbh())).wbg().wbg();
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0 = Companion_getInstance_15().fbz_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_INFO_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$7 = 'BROWSER openVfs: currentDir=' + this.nbz() + ', path=' + path + ', urlVfs=' + this_1.toString();
      tmp0.pbj(level, tmp$ret$7);
    }
    return this_1;
  }
  ebz() {
    return Companion_getInstance_11();
  }
}
class Companion_10 extends JsRuntimeBrowser {
  constructor() {
    Companion_instance_13 = null;
    super();
    Companion_instance_13 = this;
  }
}
class JsRuntimeDeno extends JsRuntimeBrowser {
  constructor() {
    Companion_getInstance_17();
    super();
  }
  nbz() {
    try {
      var str = (new URL('.', Deno.mainModule)).pathname;
      return Companion_getInstance().qb0() ? substring(str, 1) : str;
    } catch ($p) {
      var e = $p;
      return '.';
    }
  }
  bbz(path) {
    return (new DenoLocalVfs()).wi(path === '.' ? this.nbz() : path);
  }
}
class Companion_11 extends JsRuntimeDeno {
  constructor() {
    Companion_instance_14 = null;
    super();
    Companion_instance_14 = this;
  }
}
class DenoLocalVfs extends LocalVfs {
  *wbf(path, mode, $completion) {
    var options = jsObject([to('read', mode.hbh_1), to('write', mode.ebh_1), to('append', mode.ibh_1), to('truncate', mode.gbh_1), to('create', mode.ebh_1), to('mode', toInt('666', 8))]);
    var fullPath = getFullPath(this, path);
    try {
      var file = yield* await_0(Deno.open(fullPath, options), $completion);
      return toAsyncStream(DenoAsyncStreamBase.wbz(file));
    } catch ($p) {
      var e = $p;
      if (e && e.code == 'ENOENT')
        throw FileNotFoundException.pb1("Can't open file " + fullPath);
      throw e;
    }
  }
  *abg(path, $completion) {
    var tmp;
    try {
      // Inline function 'kotlin.let' call
      var it = yield* await_0(Deno.stat(getFullPath(this, path)), $completion);
      var tmp_0 = it.isDirectory;
      var tmp_1 = numberToLong(it.size);
      var tmp_2 = numberToLong(it.dev);
      var tmp2_safe_receiver = it.ino;
      var tmp0_elvis_lhs = tmp2_safe_receiver == null ? null : numberToLong(tmp2_safe_receiver);
      var tmp_3 = tmp0_elvis_lhs == null ? new Long(-1, -1) : tmp0_elvis_lhs;
      var tmp3_safe_receiver = it.mode;
      var tmp1_elvis_lhs = tmp3_safe_receiver == null ? null : numberToInt(tmp3_safe_receiver);
      tmp = this.ybg(path, tmp_0, tmp_1, tmp_2, tmp_3, tmp1_elvis_lhs == null ? toInt('777', 8) : tmp1_elvis_lhs);
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var e = $p;
        tmp_4 = this.abh(path);
      } else {
        throw $p;
      }
      tmp = tmp_4;
    }
    return tmp;
  }
}
class DenoAsyncStreamBase extends AsyncStreamBase {
  constructor(file) {
    return new.target.wbz(file);
  }
  static wbz(file) {
    var $this = this.mb8();
    $this.ubz_1 = file;
    $this.vbz_1 = false;
    return $this;
  }
  *nb8(position, buffer, offset, len, $completion) {
    yield* await_0(this.ubz_1.seek(toNumber(position), Deno.SeekMode.Start), $completion);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var read = yield* await_0(this.ubz_1.read(new Uint8Array(buffer.buffer, offset, len)), $completion);
    var tmp0_elvis_lhs = read == null ? null : numberToInt(read);
    return tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
  }
  *ob8(position, buffer, offset, len, $completion) {
    yield* await_0(this.ubz_1.seek(toNumber(position), Deno.SeekMode.Start), $completion);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    yield* await_0(this.ubz_1.write(new Uint8Array(buffer.buffer, offset, len)), $completion);
    return Unit_instance;
  }
  *pb8($completion) {
    return numberToLong((yield* await_0(this.ubz_1.stat(), $completion)).size);
  }
  *lb6($completion) {
    if (this.vbz_1)
      return Unit_instance;
    this.ubz_1.close();
    this.vbz_1 = true;
    return Unit_instance;
  }
}
class workerImpl$1 extends _WorkerImpl {
  constructor() {
    super();
    this.xbz_1 = 0;
  }
  ybz() {
    return !(get_workerUrl() == null);
  }
  uby() {
    var tmp;
    if (get_isDenoJs()) {
      tmp = Deno.mainModule;
    } else {
      var tmp5_safe_receiver = lastOrNull(Companion_instance_15.bc0().ac0_1);
      tmp = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.dc0_1;
    }
    set_workerUrl(tmp);
    if (get_workerUrl() == null) {
      println('workerUrl = null, STACKTRACE:' + stackTraceToString(Exception.te()));
    }
    if (get_isWorker_0() && this.ybz()) {
      // Inline function 'kotlin.js.asDynamic' call
      get_jsGlobalThis().onmessage = workerImpl$o$insideWorker$lambda;
    }
    return get_isWorker_0();
  }
}
class Entry {
  constructor(method, file, line, column) {
    column = column === VOID ? -1 : column;
    this.cc0_1 = method;
    this.dc0_1 = file;
    this.ec0_1 = line;
    this.fc0_1 = column;
  }
  toString() {
    return 'Entry(method=' + this.cc0_1 + ', file=' + this.dc0_1 + ', line=' + this.ec0_1 + ', column=' + this.fc0_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.cc0_1);
    result = imul(result, 31) + getStringHashCode(this.dc0_1) | 0;
    result = imul(result, 31) + this.ec0_1 | 0;
    result = imul(result, 31) + this.fc0_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.cc0_1 === tmp0_other_with_cast.cc0_1))
      return false;
    if (!(this.dc0_1 === tmp0_other_with_cast.dc0_1))
      return false;
    if (!(this.ec0_1 === tmp0_other_with_cast.ec0_1))
      return false;
    if (!(this.fc0_1 === tmp0_other_with_cast.fc0_1))
      return false;
    return true;
  }
}
class Companion_12 {
  gc0(stack, message) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var entries = ArrayList.p2();
    // Inline function 'kotlin.collections.arrayListOf' call
    var messageLines = ArrayList.p2();
    var isChrome = false;
    var iterator = lines(stack).p1();
    var index = 0;
    $l$loop: while (iterator.q1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var strLine = iterator.r1();
      // Inline function 'kotlin.text.trimEnd' call
      var strLine_0 = toString(trimEnd_0(isCharSequence(strLine) ? strLine : THROW_CCE()));
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(strLine_0) === 0) {
        tmp = !isChrome;
      } else {
        tmp = false;
      }
      if (tmp)
        continue $l$loop;
      if ((startsWith(strLine_0, 'Error: ') || strLine_0 === 'Error') && index_0 === 0) {
        isChrome = true;
        messageLines.d2(substring(strLine_0, 7));
      } else if (startsWith(strLine_0, '    at ')) {
        var part = trimEnd(substring(strLine_0, 7), charArrayOf([_Char___init__impl__6a9atx(41)]));
        var column = substringAfterLast(part, _Char___init__impl__6a9atx(58));
        var part0 = substringBeforeLast(part, _Char___init__impl__6a9atx(58));
        var line = substringAfterLast(part0, _Char___init__impl__6a9atx(58));
        var part1 = substringBeforeLast(part0, _Char___init__impl__6a9atx(58));
        var tmp_0;
        if (contains_0(part1, _Char___init__impl__6a9atx(40))) {
          // Inline function 'kotlin.collections.map' call
          var this_0 = split(part1, ['(']);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.p1();
          while (_iterator__ex2g4s.q1()) {
            var item = _iterator__ex2g4s.r1();
            // Inline function 'kotlin.text.trim' call
            var tmp$ret$6 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
            destination.d2(tmp$ret$6);
          }
          tmp_0 = destination;
        } else {
          // Inline function 'kotlin.text.trim' call
          var tmp$ret$8 = toString(trim(isCharSequence(part1) ? part1 : THROW_CCE()));
          tmp_0 = listOf(['', tmp$ret$8]);
        }
        var _destruct__k2r9zo = tmp_0;
        // Inline function 'kotlin.collections.component1' call
        var method = _destruct__k2r9zo.u2(0);
        // Inline function 'kotlin.collections.component2' call
        var file = _destruct__k2r9zo.u2(1);
        var tmp0_elvis_lhs = toIntOrNull(line);
        var tmp_1 = tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = toIntOrNull(column);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new Entry(method, file, tmp_1, tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs);
        entries.d2(element);
      } else if (isChrome) {
        messageLines.d2(strLine_0);
      } else {
        var cline = strLine_0;
        // Inline function 'kotlin.collections.arrayListOf' call
        var numParts = ArrayList.p2();
        var inductionVariable = 0;
        if (inductionVariable < 2)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp_2 = Regex.hi('^(.*):(\\d+)$');
            var tmp_3 = cline;
            cline = tmp_2.ni(tmp_3, JSStackTrace$Companion$parse$lambda(numParts));
          }
           while (inductionVariable < 2);
        var file_0 = substringAfterLast(cline, _Char___init__impl__6a9atx(64));
        var method_0 = substringBeforeLast(cline, _Char___init__impl__6a9atx(64));
        var tmp2_elvis_lhs = firstOrNull(numParts);
        var line_0 = tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
        var tmp_4;
        if (numParts.s2() >= 2) {
          var tmp3_elvis_lhs = lastOrNull(numParts);
          tmp_4 = tmp3_elvis_lhs == null ? -1 : tmp3_elvis_lhs;
        } else {
          tmp_4 = -1;
        }
        var column_0 = tmp_4;
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = new Entry(method_0, file_0, line_0, column_0);
        entries.d2(element_0);
      }
    }
    if (!isChrome) {
      messageLines = arrayListOf([message == null ? '' : message]);
    }
    if (entries.n1()) {
      entries.d2(new Entry('<unknown>', '<unknown>', -1));
    }
    return new JSStackTrace(joinToString(messageLines, '\n'), entries);
  }
  hc0(e) {
    return this.gc0(stackTraceToString(e), e.message);
  }
  bc0() {
    return this.hc0(Exception.c6(''));
  }
}
class JSStackTrace {
  constructor(message, entries) {
    this.zbz_1 = message;
    this.ac0_1 = entries;
  }
  toString() {
    return 'JSStackTrace(message=' + this.zbz_1 + ', entries=' + toString(this.ac0_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.zbz_1);
    result = imul(result, 31) + hashCode(this.ac0_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof JSStackTrace))
      return false;
    var tmp0_other_with_cast = other instanceof JSStackTrace ? other : THROW_CCE();
    if (!(this.zbz_1 === tmp0_other_with_cast.zbz_1))
      return false;
    if (!equals(this.ac0_1, tmp0_other_with_cast.ac0_1))
      return false;
    return true;
  }
}
//endregion
function get_logger() {
  _init_properties_AsyncExt_kt__ahev1h();
  return logger;
}
var logger;
var DEFAULT_SUSPEND_TEST_TIMEOUT;
var DEFAULT_TEST_SYNC_IO;
function get_DEBUG_ASYNC_LAUNCH_ERRORS() {
  _init_properties_AsyncExt_kt__ahev1h();
  var tmp0 = DEBUG_ASYNC_LAUNCH_ERRORS$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('DEBUG_ASYNC_LAUNCH_ERRORS', 0, tmp, _get_DEBUG_ASYNC_LAUNCH_ERRORS_$ref_5jl6a0(), null);
  return tmp0.k3();
}
var DEBUG_ASYNC_LAUNCH_ERRORS$delegate;
function launchImmediately(context, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  return launchImmediately_0(CoroutineScope(context), callback);
}
function launchImmediately_0(_this__u8e3s4, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  return _launch(_this__u8e3s4, CoroutineStart_UNDISPATCHED_getInstance(), callback);
}
function *launchUnscopedAndWait(_this__u8e3s4, block, $completion) {
  var deferred = CompletableDeferred();
  startCoroutine(block, new launchUnscopedAndWait$2(_this__u8e3s4, deferred));
  return yield* deferred.m1q($completion);
}
function launchUnscoped(_this__u8e3s4, block) {
  _init_properties_AsyncExt_kt__ahev1h();
  return launchUnscoped_0(_this__u8e3s4.d1m(), block);
}
function launchUnscoped_0(_this__u8e3s4, block) {
  _init_properties_AsyncExt_kt__ahev1h();
  startCoroutine(block, new launchUnscoped$1(_this__u8e3s4));
}
function _launch(_this__u8e3s4, start, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  var tmp = _this__u8e3s4.d1m();
  return launch(_this__u8e3s4, tmp, start, _launch$slambda(callback));
}
function DEBUG_ASYNC_LAUNCH_ERRORS$delegate$lambda() {
  _init_properties_AsyncExt_kt__ahev1h();
  return Companion_instance_0.wi('DEBUG_ASYNC_LAUNCH_ERRORS') === 'true';
}
function _get_DEBUG_ASYNC_LAUNCH_ERRORS_$ref_5jl6a0() {
  return constructCallableReference(() => get_DEBUG_ASYNC_LAUNCH_ERRORS(), 0, 0, 93);
}
function _launch$slambda($callback) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      tmp = yield* $callback($completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          if (get_DEBUG_ASYNC_LAUNCH_ERRORS()) {
            // Inline function 'korlibs.logger.Logger.error' call
            var tmp0 = get_logger();
            // Inline function 'korlibs.logger.Logger.log' call
            var level = Level_ERROR_getInstance();
            if (tmp0.obj(level)) {
              var tmp$ret$2 = 'CoroutineScope._launch.catch:';
              tmp0.pbj(level, tmp$ret$2);
            }
            printStackTrace(e_0);
          }
          throw e_0;
        } else {
          throw $p;
        }
      }
    }
    return Unit_instance;
  }, 1);
}
var properties_initialized_AsyncExt_kt_7k2grr;
function _init_properties_AsyncExt_kt__ahev1h() {
  if (!properties_initialized_AsyncExt_kt_7k2grr) {
    properties_initialized_AsyncExt_kt_7k2grr = true;
    logger = Companion_getInstance_0().pb5('AsyncExt');
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_SUSPEND_TEST_TIMEOUT = toDuration(20, DurationUnit_SECONDS_getInstance());
    DEFAULT_TEST_SYNC_IO = false;
    DEBUG_ASYNC_LAUNCH_ERRORS$delegate = lazy(DEBUG_ASYNC_LAUNCH_ERRORS$delegate$lambda);
  }
}
function CatalogVfs$open$slambda(this$0, $path, $mode) {
  return constructCallableReference(function *($this$withContext, $completion) {
    return (yield* protoOf(Proxy).wbf.call(this$0, $path, $mode, $completion)).xb8_1;
  }, 1);
}
var resourcesVfsDebug;
function get_resourcesVfs() {
  return get_standardVfs().ubr();
}
function get_localCurrentDirVfs() {
  return get_applicationVfs();
}
function unmountInternal($this, folder) {
  removeAll($this.xbr_1, MountableVfs$unmountInternal$lambda(folder));
}
function resort($this) {
  // Inline function 'kotlin.collections.sortByDescending' call
  var this_0 = $this.xbr_1;
  if (this_0.s2() > 1) {
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = MountableVfs$resort$lambda;
    var tmp$ret$1 = new sam$kotlin_Comparator$0(tmp);
    sortWith(this_0, tmp$ret$1);
  }
}
function MountableVfs$unmountInternal$lambda($folder) {
  return (it) => it.pm_1 === normalize(get_pathInfo($folder));
}
function MountableVfs$resort$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.pm_1.length;
  var tmp$ret$2 = a.pm_1.length;
  return compareValues(tmp, tmp$ret$2);
}
function UrlVfs_0(url, client, failFromStatus) {
  client = client === VOID ? createHttpClient() : client;
  failFromStatus = failFromStatus === VOID ? true : failFromStatus;
  return UrlVfs_1(url.nbs(VOID, VOID, VOID, VOID, VOID, '', null).obs(), Unit_instance, client, failFromStatus).wi(url.gbs_1);
}
function *_readRangeBase($this, fullUrl, range, $completion) {
  // Inline function 'kotlin.also' call
  var this_0 = yield* $this.tbs_1.ibt(Companion_getInstance_6().wbs_1, fullUrl, Headers.hbt(range.equals(get_LONG_ZERO_TO_MAX_RANGE()) ? LinkedHashMap.m7() : linkedHashMapOf([to('range', 'bytes=' + range.s3().toString() + '-' + range.r3().toString())])), VOID, VOID, $completion);
  if ($this.cbi_1) {
    if (this_0.jbt_1 === 404)
      throw FileNotFoundException.pb1(fullUrl + ' not found');
    yield* this_0.qbt($completion);
  }
  return this_0;
}
function UrlVfs_1(url, dummy, client, failFromStatus) {
  client = client === VOID ? createHttpClient() : client;
  failFromStatus = failFromStatus === VOID ? true : failFromStatus;
  return new FinalUrlVfs(url, dummy, client, failFromStatus);
}
function UrlVfs_2(url, client, failFromStatus) {
  client = client === VOID ? createHttpClient() : client;
  failFromStatus = failFromStatus === VOID ? true : failFromStatus;
  return UrlVfs_0(Companion_getInstance_5().pb5(url), client, failFromStatus);
}
function currentStackTrace(msg) {
  msg = msg === VOID ? 'printStackTrace' : msg;
  return stackTraceToString(Exception.c6(msg));
}
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 === VOID)
    new Companion();
  return Companion_instance_2;
}
function URL$fullUrl$delegate$lambda(this$0) {
  return () => this$0.pbu().toString();
}
function URL$_get_fullUrl_$ref_2cgnp1() {
  return constructCallableReference((p0) => p0.obs(), 1, 0, 94);
}
function URL$fullUrlWithoutScheme$delegate$lambda(this$0) {
  return () => this$0.pbu(false).toString();
}
function URL$pathWithQuery$delegate$lambda(this$0) {
  return () => {
    var tmp;
    if (!(this$0.hbs_1 == null)) {
      tmp = this$0.gbs_1 + '?' + this$0.hbs_1;
    } else {
      tmp = this$0.gbs_1;
    }
    return tmp;
  };
}
function normalizeUrl(_this__u8e3s4) {
  // Inline function 'kotlin.text.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.text.firstOrNull' call
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
      var element = charSequenceGet(_this__u8e3s4, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (element === _Char___init__impl__6a9atx(63) || element === _Char___init__impl__6a9atx(35)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var tmp;
  var tmp_0 = tmp0_elvis_lhs;
  if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
    tmp = _Char___init__impl__6a9atx(63);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paramFlag = tmp;
  var pathParts = toMutableList(split_0(_this__u8e3s4, charArrayOf([paramFlag])));
  pathParts.e5(0, normalize(get_pathInfo(pathParts.u2(0)), false));
  return joinToString(pathParts, toString_1(paramFlag));
}
var Methods_ALL_instance;
var Methods_OPTIONS_instance;
var Methods_GET_instance;
var Methods_HEAD_instance;
var Methods_POST_instance;
var Methods_PUT_instance;
var Methods_DELETE_instance;
var Methods_TRACE_instance;
var Methods_CONNECT_instance;
var Methods_PATCH_instance;
var Methods_entriesInitialized;
function Methods_initEntries() {
  if (Methods_entriesInitialized)
    return Unit_instance;
  Methods_entriesInitialized = true;
  Methods_ALL_instance = new Methods('ALL', 0);
  Methods_OPTIONS_instance = new Methods('OPTIONS', 1);
  Methods_GET_instance = new Methods('GET', 2);
  Methods_HEAD_instance = new Methods('HEAD', 3);
  Methods_POST_instance = new Methods('POST', 4);
  Methods_PUT_instance = new Methods('PUT', 5);
  Methods_DELETE_instance = new Methods('DELETE', 6);
  Methods_TRACE_instance = new Methods('TRACE', 7);
  Methods_CONNECT_instance = new Methods('CONNECT', 8);
  Methods_PATCH_instance = new Methods('PATCH', 9);
}
var Companion_instance_3;
function Companion_getInstance_6() {
  if (Companion_instance_3 === VOID)
    new Companion_0();
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_7() {
  return Companion_instance_4;
}
var Companion_instance_5;
function Companion_getInstance_8() {
  return Companion_instance_5;
}
function Http$Headers$toListGrouped$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = a.pm_1.toLowerCase();
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$4 = b.pm_1.toLowerCase();
  return compareValues(tmp, tmp$ret$4);
}
function Methods_OPTIONS_getInstance() {
  Methods_initEntries();
  return Methods_OPTIONS_instance;
}
function Methods_GET_getInstance() {
  Methods_initEntries();
  return Methods_GET_instance;
}
function Methods_HEAD_getInstance() {
  Methods_initEntries();
  return Methods_HEAD_instance;
}
function Methods_POST_getInstance() {
  Methods_initEntries();
  return Methods_POST_instance;
}
function Methods_PUT_getInstance() {
  Methods_initEntries();
  return Methods_PUT_instance;
}
function Methods_DELETE_getInstance() {
  Methods_initEntries();
  return Methods_DELETE_instance;
}
function Methods_TRACE_getInstance() {
  Methods_initEntries();
  return Methods_TRACE_instance;
}
function Methods_CONNECT_getInstance() {
  Methods_initEntries();
  return Methods_CONNECT_instance;
}
function Methods_PATCH_getInstance() {
  Methods_initEntries();
  return Methods_PATCH_instance;
}
function get__defaultHttpFactory() {
  _init_properties_HttpClient_kt__huy6s3();
  var tmp0 = _defaultHttpFactory$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_defaultHttpFactory', 0, tmp, _get__defaultHttpFactory_$ref_woz94w(), null);
  return tmp0.k3();
}
var _defaultHttpFactory$delegate;
var Companion_instance_6;
function Companion_getInstance_9() {
  return Companion_instance_6;
}
function HttpClient$Response$responseCharset$delegate$lambda() {
  return get_UTF8();
}
function HttpClient$Response$_get_responseCharset_$ref_osz7el() {
  return constructCallableReference((p0) => p0.mbv(), 1, 0, 95);
}
var Companion_instance_7;
function Companion_getInstance_10() {
  if (Companion_instance_7 === VOID)
    new Companion_4();
  return Companion_instance_7;
}
function mergeUrls($this, base, append) {
  return Companion_getInstance_5().obu(base, append);
}
var Companion_instance_8;
function Companion_getInstance_11() {
  if (Companion_instance_8 === VOID)
    new Companion_5();
  return Companion_instance_8;
}
function createHttpClient() {
  _init_properties_HttpClient_kt__huy6s3();
  return get_defaultHttpFactory().qbw();
}
var HttpStatusMessage_instance;
function HttpStatusMessage_getInstance() {
  if (HttpStatusMessage_instance === VOID)
    new HttpStatusMessage();
  return HttpStatusMessage_instance;
}
function *withContentEncoding(_this__u8e3s4, contentEncoding, $completion) {
  var input = _this__u8e3s4;
  var tmp;
  switch (contentEncoding) {
    case '':
    case 'plain':
      tmp = input;
      break;
    case 'gzip':
      tmp = yield* uncompressed(input, Companion_getInstance_3(), VOID, $completion);
      break;
    case 'deflate':
      tmp = yield* uncompressed(input, get_Deflate(), VOID, $completion);
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = "Unsupported Content-Encoding '" + contentEncoding + "'";
      throw IllegalStateException.o(toString(message));
  }
  return tmp;
}
function *withTransferEncoding(_this__u8e3s4, transferEncoding, $completion) {
  var input = _this__u8e3s4;
  var tmp;
  switch (transferEncoding) {
    case '':
    case 'identity':
      tmp = input;
      break;
    case 'chunked':
      tmp = yield* asyncStreamWriter(VOID, 'chunked', VOID, withTransferEncoding$slambda(input), $completion);
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = "Unsupported Transfer-Encoding '" + transferEncoding + "'";
      throw IllegalStateException.o(toString(message));
  }
  return tmp;
}
function createHttpClientFromFetch(fetch) {
  fetch = fetch === VOID ? Companion_getInstance_4() : fetch;
  _init_properties_HttpClient_kt__huy6s3();
  return new createHttpClientFromFetch$1(fetch);
}
function get_defaultHttpFactory() {
  _init_properties_HttpClient_kt__huy6s3();
  return get__defaultHttpFactory();
}
function _defaultHttpFactory$delegate$lambda() {
  _init_properties_HttpClient_kt__huy6s3();
  return new ProxiedHttpFactory(get_httpFactory());
}
function _get__defaultHttpFactory_$ref_woz94w() {
  return constructCallableReference(() => get__defaultHttpFactory(), 0, 0, 96);
}
function withTransferEncoding$slambda($input) {
  return constructCallableReference(function *(out, $completion) {
    do {
      // Inline function 'kotlin.text.trim' call
      var this_0 = yield* readLine($input, VOID, VOID, VOID, 16, VOID, $completion);
      var nbytesString = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      var tmp0_elvis_lhs = toIntOrNull_0(nbytesString, 16);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.error' call
        var message = "Can't convert '" + nbytesString + "' into int for chunked encoding";
        throw IllegalStateException.o(toString(message));
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nbytes = tmp;
      if (nbytes > 0) {
        var bytes = yield* readBytesExact($input, nbytes, $completion);
        yield* out.jb6(bytes, VOID, VOID, $completion);
        yield* readLine($input, VOID, VOID, VOID, 2, VOID, $completion);
      }
    }
     while (nbytes > 0);
    return Unit_instance;
  }, 1);
}
var properties_initialized_HttpClient_kt_t7kzvv;
function _init_properties_HttpClient_kt__huy6s3() {
  if (!properties_initialized_HttpClient_kt_t7kzvv) {
    properties_initialized_HttpClient_kt_t7kzvv = true;
    _defaultHttpFactory$delegate = lazy(_defaultHttpFactory$delegate$lambda);
  }
}
var EmptyLineOnce_instance;
function EmptyLineOnce_getInstance() {
  return EmptyLineOnce_instance;
}
var Indent_instance;
function Indent_getInstance() {
  return Indent_instance;
}
var Unindent_instance;
function Unindent_getInstance() {
  return Unindent_instance;
}
var INDENTS_instance;
function INDENTS_getInstance_0() {
  return INDENTS_instance;
}
var Companion_instance_9;
function Companion_getInstance_12() {
  if (Companion_instance_9 === VOID)
    new Companion_6();
  return Companion_instance_9;
}
function get_LONG_ZERO_TO_MAX_RANGE() {
  _init_properties_RangeExt_kt__vz0y4k();
  return LONG_ZERO_TO_MAX_RANGE;
}
var LONG_ZERO_TO_MAX_RANGE;
var properties_initialized_RangeExt_kt_dqkq5i;
function _init_properties_RangeExt_kt__vz0y4k() {
  if (!properties_initialized_RangeExt_kt_dqkq5i) {
    properties_initialized_RangeExt_kt_dqkq5i = true;
    LONG_ZERO_TO_MAX_RANGE = longRangeToLong(new Long(0, 0), new Long(-1, 2147483647));
  }
}
function get_length(_this__u8e3s4) {
  return (_this__u8e3s4.o3_1 - _this__u8e3s4.n3_1 | 0) + 1 | 0;
}
var Companion_instance_10;
function Companion_getInstance_13() {
  return Companion_instance_10;
}
function posSkip($this, count) {
  var out = $this.hbu_1;
  $this.hbu_1 = $this.hbu_1 + count | 0;
  return out;
}
function substr($this, pos, length) {
  // Inline function 'kotlin.math.min' call
  var b = $this.jbu_1;
  var tmp = Math.min(pos, b);
  var tmp0 = pos + length | 0;
  // Inline function 'kotlin.math.min' call
  var b_0 = $this.jbu_1;
  var tmp$ret$1 = Math.min(tmp0, b_0);
  return substring_0($this.fbu_1, tmp, tmp$ret$1);
}
function get_DEBUG_WORKER() {
  _init_properties_Worker_kt__eidt7m();
  return DEBUG_WORKER;
}
var DEBUG_WORKER;
function DemoWorkerTask$execute$slambda() {
  return constructCallableReference(function *(params, $completion) {
    println('TEST!!!!! ' + toString(params));
    return 11;
  }, 1);
}
var Companion_instance_11;
function Companion_getInstance_14() {
  return Companion_instance_11;
}
function WorkerTask$runSuspend$slambda($deferred, this$0, $block) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.runCatching' call
    var this_0 = this$0;
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = yield* $block(this_0.pby(), $completion);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp$ret$0 = tmp;
    completeWith($deferred, tmp$ret$0);
    return Unit_instance;
  }, 0);
}
var properties_initialized_Worker_kt_gr88g0;
function _init_properties_Worker_kt__eidt7m() {
  if (!properties_initialized_Worker_kt_gr88g0) {
    properties_initialized_Worker_kt_gr88g0 = true;
    DEBUG_WORKER = Companion_instance_0.wi('DEBUG_WORKER') === 'true';
  }
}
function *delay_0(time, $completion) {
  yield* delay(numberToLong(_FastDuration___get_milliseconds__impl__ffr17u(time)), $completion);
  return Unit_instance;
}
function get_jsGlobalDynamic() {
  _init_properties_KorioNativeJs_kt__151su();
  return jsGlobalDynamic;
}
var jsGlobalDynamic;
var jsGlobal;
function get_isDenoJs() {
  _init_properties_KorioNativeJs_kt__151su();
  var tmp0 = isDenoJs$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('isDenoJs', 0, tmp, _get_isDenoJs_$ref_1x6n2z(), null);
  return tmp0.k3();
}
var isDenoJs$delegate;
function get_isWeb() {
  _init_properties_KorioNativeJs_kt__151su();
  var tmp0 = isWeb$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('isWeb', 0, tmp, _get_isWeb_$ref_nuw7ue(), null);
  return tmp0.k3();
}
var isWeb$delegate;
function get_isWorker() {
  _init_properties_KorioNativeJs_kt__151su();
  var tmp0 = isWorker$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('isWorker', 0, tmp, _get_isWorker_$ref_bx337y(), null);
  return tmp0.k3();
}
var isWorker$delegate;
function get_isNodeJs() {
  _init_properties_KorioNativeJs_kt__151su();
  var tmp0 = isNodeJs$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('isNodeJs', 0, tmp, _get_isNodeJs_$ref_y8oeqt(), null);
  return tmp0.k3();
}
var isNodeJs$delegate;
function set__jsRuntime(_set____db54di) {
  _init_properties_KorioNativeJs_kt__151su();
  _jsRuntime = _set____db54di;
}
function get__jsRuntime() {
  _init_properties_KorioNativeJs_kt__151su();
  return _jsRuntime;
}
var _jsRuntime;
function get_jsRuntime() {
  _init_properties_KorioNativeJs_kt__151su();
  var tmp0_elvis_lhs = get__jsRuntime();
  set__jsRuntime(tmp0_elvis_lhs == null ? get_isDenoJs() ? Companion_getInstance_17() : Companion_getInstance_16() : tmp0_elvis_lhs);
  return ensureNotNull(get__jsRuntime());
}
function get_isShell() {
  _init_properties_KorioNativeJs_kt__151su();
  return !get_isWeb() && !get_isNodeJs() && !get_isWorker();
}
function isDenoJs$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof Deno === 'object' && Deno.statSync !== undefined;
}
function _get_isDenoJs_$ref_1x6n2z() {
  return constructCallableReference(() => get_isDenoJs(), 0, 0, 97);
}
function isWeb$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof window === 'object';
}
function _get_isWeb_$ref_nuw7ue() {
  return constructCallableReference(() => get_isWeb(), 0, 0, 98);
}
function isWorker$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof importScripts === 'function';
}
function _get_isWorker_$ref_bx337y() {
  return constructCallableReference(() => get_isWorker(), 0, 0, 99);
}
function isNodeJs$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof process !== 'undefined' && process.release && process.release.name.search(/node|io.js/) !== -1;
}
function _get_isNodeJs_$ref_y8oeqt() {
  return constructCallableReference(() => get_isNodeJs(), 0, 0, 100);
}
var properties_initialized_KorioNativeJs_kt_y4p8os;
function _init_properties_KorioNativeJs_kt__151su() {
  if (!properties_initialized_KorioNativeJs_kt_y4p8os) {
    properties_initialized_KorioNativeJs_kt_y4p8os = true;
    jsGlobalDynamic = typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : self;
    jsGlobal = get_jsGlobalDynamic();
    isDenoJs$delegate = lazy(isDenoJs$delegate$lambda);
    isWeb$delegate = lazy(isWeb$delegate$lambda);
    isWorker$delegate = lazy(isWorker$delegate$lambda);
    isNodeJs$delegate = lazy(isNodeJs$delegate$lambda);
    _jsRuntime = null;
  }
}
function toVfs(_this__u8e3s4) {
  var file = _this__u8e3s4;
  return (new toVfs$1(file)).wi(file.name);
}
function openAsync_0(_this__u8e3s4) {
  return buffered(toAsyncStream(BlobAsyncBaseStream.wby(_this__u8e3s4)), 65536, 16);
}
function BlobAsyncBaseStream$read$lambda($reader, $len, $buffer, $offset, $deferred) {
  return (it) => {
    // Inline function 'kotlin.js.unsafeCast' call
    var ab = $reader.result;
    var tmp0 = ab.byteLength;
    // Inline function 'kotlin.math.min' call
    var b = $len;
    var minLen = Math.min(tmp0, b);
    arraycopy(toByteArray(new Int8Array(ab)), 0, $buffer, $offset, minLen);
    return $deferred.l1t(minLen);
  };
}
function BlobAsyncBaseStream$read$lambda_0($deferred, $reader) {
  return (it) => $deferred.k1t(newThrowable('' + $reader.error));
}
function get_standardVfs() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return standardVfs;
}
var standardVfs;
function get_applicationVfs() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  var tmp0 = applicationVfs$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('applicationVfs', 0, tmp, _get_applicationVfs_$ref_lyfxmv(), null);
  return tmp0.k3();
}
var applicationVfs$delegate;
var applicationDataVfsOrNull;
var cacheVfsOrNull;
var externalStorageVfs$delegate;
var userHomeVfs$delegate;
var tempVfsOrNull;
function localVfs(path, async) {
  async = async === VOID ? true : async;
  _init_properties_LocalVfsJs_kt__kywvdr();
  return get_jsRuntime().bbz(path);
}
function standardVfs$o$resourcesVfs$delegate$lambda() {
  return get_applicationVfs().vbh();
}
function standardVfs$o$_get_resourcesVfs_$ref_bvytcf() {
  return constructCallableReference((p0) => p0.ubr(), 1, 0, 101);
}
function standardVfs$o$rootLocalVfs$delegate$lambda() {
  return localVfs('.');
}
function applicationVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
function _get_applicationVfs_$ref_lyfxmv() {
  return constructCallableReference(() => get_applicationVfs(), 0, 0, 102);
}
function externalStorageVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
function userHomeVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
var properties_initialized_LocalVfsJs_kt_51m659;
function _init_properties_LocalVfsJs_kt__kywvdr() {
  if (!properties_initialized_LocalVfsJs_kt_51m659) {
    properties_initialized_LocalVfsJs_kt_51m659 = true;
    standardVfs = new standardVfs$1();
    applicationVfs$delegate = lazy(applicationVfs$delegate$lambda);
    applicationDataVfsOrNull = null;
    cacheVfsOrNull = null;
    externalStorageVfs$delegate = lazy(externalStorageVfs$delegate$lambda);
    userHomeVfs$delegate = lazy(userHomeVfs$delegate$lambda);
    tempVfsOrNull = null;
  }
}
var StandardPaths_instance;
function StandardPaths_getInstance() {
  return StandardPaths_instance;
}
function get_httpFactory() {
  _init_properties_HttpFactoryJs_kt__a3ro2v();
  var tmp0 = httpFactory$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('httpFactory', 0, tmp, _get_httpFactory_$ref_cvl9zy(), null);
  return tmp0.k3();
}
var httpFactory$delegate;
function httpFactory$delegate$lambda() {
  _init_properties_HttpFactoryJs_kt__a3ro2v();
  return new httpFactory$2$1();
}
function _get_httpFactory_$ref_cvl9zy() {
  return constructCallableReference(() => get_httpFactory(), 0, 0, 103);
}
var properties_initialized_HttpFactoryJs_kt_on1x9h;
function _init_properties_HttpFactoryJs_kt__a3ro2v() {
  if (!properties_initialized_HttpFactoryJs_kt_on1x9h) {
    properties_initialized_HttpFactoryJs_kt_on1x9h = true;
    httpFactory$delegate = lazy(httpFactory$delegate$lambda);
  }
}
var Companion_instance_12;
function Companion_getInstance_15() {
  if (Companion_instance_12 === VOID)
    new Companion_9();
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_16() {
  if (Companion_instance_13 === VOID)
    new Companion_10();
  return Companion_instance_13;
}
function JsRuntimeBrowser$href$delegate$lambda() {
  var tmp1_safe_receiver = document.location;
  var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.href;
  return tmp0_elvis_lhs == null ? '.' : tmp0_elvis_lhs;
}
function JsRuntimeBrowser$_get_href_$ref_bj91mu() {
  return constructCallableReference((p0) => p0.lbz(), 1, 0, 104);
}
function JsRuntimeBrowser$baseUrl$delegate$lambda(this$0) {
  return () => endsWith(this$0.lbz(), '/') ? this$0.lbz() : substringBeforeLast(this$0.lbz(), _Char___init__impl__6a9atx(47));
}
function JsRuntimeBrowser$_get_baseUrl_$ref_np3n1z() {
  return constructCallableReference((p0) => p0.mbz(), 1, 0, 105);
}
var Companion_instance_14;
function Companion_getInstance_17() {
  if (Companion_instance_14 === VOID)
    new Companion_11();
  return Companion_instance_14;
}
function getFullPath($this, path) {
  return normalize(get_pathInfo(path));
}
function toByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var tout = _this__u8e3s4;
  var tmp;
  if (!(tout == null) ? isByteArray(tout) : false) {
    // Inline function 'kotlin.js.unsafeCast' call
    tmp = tout;
  } else {
    var out = new Int8Array(_this__u8e3s4.length);
    var inductionVariable = 0;
    var last = out.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        out[n] = _this__u8e3s4[n];
      }
       while (inductionVariable <= last);
    tmp = out;
  }
  return tmp;
}
function set_workerUrl(_set____db54di) {
  _init_properties_Worker_js_kt__6mcbpj();
  workerUrl = _set____db54di;
}
function get_workerUrl() {
  _init_properties_Worker_js_kt__6mcbpj();
  return workerUrl;
}
var workerUrl;
function get_workerImpl() {
  _init_properties_Worker_js_kt__6mcbpj();
  return workerImpl;
}
var workerImpl;
function get_isWorker_0() {
  _init_properties_Worker_js_kt__6mcbpj();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof DedicatedWorkerGlobalScope === 'function';
}
function workerImpl$o$insideWorker$lambda(evt) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var input = evt.data;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var id = input[0];
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_elvis_lhs = input[1];
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? get_workerUrl() : tmp0_elvis_lhs;
  var moduleUrl = tmp1_elvis_lhs == null ? '.' : tmp1_elvis_lhs;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var clazzName = input[2];
  var params = drop(input, 3);
  var tmp = import(moduleUrl);
  var tmp_0 = tmp instanceof Promise ? tmp : THROW_CCE();
  var imported = tmp_0.then(workerImpl$o$insideWorker$lambda$lambda(clazzName, params, id));
  return Unit_instance;
}
function workerImpl$o$insideWorker$lambda$lambda$slambda($workerTask, $id) {
  return constructCallableReference(function *($completion) {
    var tmp;
    try {
      $workerTask.hby();
      var result = $workerTask.lby_1;
      if (!(result == null) ? isInterface(result, Deferred) : false) {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = get_jsGlobalThis();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = [$id, 'ok', yield* result.m1q($completion)];
        tmp$ret$0.postMessage(tmp$ret$1);
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$4 = get_jsGlobalThis();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [$id, 'ok', result];
        tmp$ret$4.postMessage(tmp$ret$5);
      }
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      var e = $p;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$8 = get_jsGlobalThis();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$9 = [$id, 'error', e.stack];
      tmp_0 = tmp$ret$8.postMessage(tmp$ret$9);
      tmp = tmp_0;
    }
    return Unit_instance;
  }, 0);
}
function workerImpl$o$insideWorker$lambda$lambda($clazzName, $params, $id) {
  return (imported) => {
    // Inline function 'kotlin.js.asDynamic' call
    var taskClass = imported[$clazzName];
    // Inline function 'kotlin.js.unsafeCast' call
    var workerTask = jsNew(taskClass);
    workerTask.kby_1 = toList_0($params);
    var tmp = EmptyCoroutineContext_getInstance();
    return launchImmediately(tmp, workerImpl$o$insideWorker$lambda$lambda$slambda(workerTask, $id));
  };
}
var properties_initialized_Worker_js_kt_gnq77b;
function _init_properties_Worker_js_kt__6mcbpj() {
  if (!properties_initialized_Worker_js_kt_gnq77b) {
    properties_initialized_Worker_js_kt_gnq77b = true;
    var tmp0_elvis_lhs = globalThis.location;
    workerUrl = tmp0_elvis_lhs == null ? get_isDenoJs() ? Deno.mainModule : '.' : tmp0_elvis_lhs;
    workerImpl = new workerImpl$1();
  }
}
function JSStackTrace$Companion$parse$lambda($numParts) {
  return (it) => {
    var tmp0_elvis_lhs = toIntOrNull(it.nj().u2(2));
    $numParts.f5(0, tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs);
    return it.nj().u2(1);
  };
}
var Companion_instance_15;
function Companion_getInstance_18() {
  return Companion_instance_15;
}
//region block: post-declaration
initMetadataForClass(launchUnscopedAndWait$2, VOID, VOID, VOID, [Continuation]);
initMetadataForClass(launchUnscoped$1, VOID, VOID, VOID, [Continuation]);
initMetadataForClass(CatalogVfs$open$2, VOID, VOID, VOID, VOID, [4, 1, 0]);
initMetadataForClass(CatalogVfs, 'CatalogVfs', VOID, VOID, VOID, [2, 1, 0, 4, 3]);
initMetadataForClass(StandardVfs, 'StandardVfs', StandardVfs);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(MountableVfs, 'MountableVfs', VOID, VOID, VOID, [0, 1, 4, 2, 3]);
initMetadataForInterface(StandardPathsBase, 'StandardPathsBase');
initMetadataForClass(FinalUrlVfs$open$2, VOID, VOID, VOID, VOID, [4, 0, 1]);
initMetadataForClass(FinalUrlVfs, 'FinalUrlVfs', VOID, VOID, VOID, [2, 1, 3, 0, 4]);
initMetadataForCompanion(Companion);
initMetadataForClass(URL_0, 'URL');
initMetadataForCompanion(Companion_0);
initMetadataForCompanion(Companion_1);
initMetadataForCompanion(Companion_2);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(Methods, 'Methods');
initMetadataForClass(HttpException, 'HttpException');
initMetadataForClass(Headers, 'Headers', VOID, VOID, [Iterable]);
initMetadataForCompanion(Companion_3, VOID, VOID, [4]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Response, 'Response', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(CompletedResponse, 'CompletedResponse');
initMetadataForClass(RequestConfig, 'RequestConfig', RequestConfig);
initMetadataForInterface(HttpClient, 'HttpClient', VOID, VOID, VOID, [4, 5, 2]);
protoOf(Companion_5).ibt = request$default;
protoOf(Companion_5).nbw = requestAsBytes$default;
protoOf(Companion_5).xbt = readBytes$default;
initMetadataForCompanion(Companion_5, VOID, [HttpClient], [4, 5, 2]);
initMetadataForObject(HttpStatusMessage, 'HttpStatusMessage');
initMetadataForClass(ProxiedHttpFactory, 'ProxiedHttpFactory');
protoOf(createHttpClientFromFetch$1).lbw = request;
protoOf(createHttpClientFromFetch$1).ibt = request$default;
protoOf(createHttpClientFromFetch$1).mbw = requestAsBytes;
protoOf(createHttpClientFromFetch$1).nbw = requestAsBytes$default;
protoOf(createHttpClientFromFetch$1).obw = readBytes;
protoOf(createHttpClientFromFetch$1).xbt = readBytes$default;
initMetadataForClass(createHttpClientFromFetch$1, VOID, VOID, VOID, [HttpClient], [4, 5, 2]);
initMetadataForClass(Resources, 'Resources');
initMetadataForInterface(Text, 'Text');
initMetadataForClass(Marker, 'Marker');
initMetadataForClass(Line, 'Line', VOID, VOID, [Text]);
initMetadataForClass(LineDeferred, 'LineDeferred');
initMetadataForObject(EmptyLineOnce, 'EmptyLineOnce');
initMetadataForObject(Indent, 'Indent');
initMetadataForObject(Unindent, 'Unindent');
initMetadataForObject(INDENTS, 'INDENTS');
initMetadataForCompanion(Companion_6);
initMetadataForClass(IndenterEvaluator, 'IndenterEvaluator');
initMetadataForClass(Indenter, 'Indenter', Indenter);
initMetadataForClass(Once, 'Once', Once);
initMetadataForCompanion(Companion_7);
protoOf(BaseStrReader).zb5 = toStringContext;
initMetadataForClass(BaseStrReader, 'BaseStrReader', VOID, VOID, [SimpleStrReader]);
initMetadataForClass(StrReader, 'StrReader');
initMetadataForClass(WorkerTask, 'WorkerTask', WorkerTask);
initMetadataForClass(DemoWorkerTask, 'DemoWorkerTask', DemoWorkerTask);
initMetadataForCompanion(Companion_8);
initMetadataForClass(_WorkerImpl, '_WorkerImpl', _WorkerImpl, VOID, VOID, [4]);
initMetadataForClass(BlobAsyncBaseStream, 'BlobAsyncBaseStream', VOID, VOID, VOID, [0, 4, 1]);
initMetadataForClass(toVfs$1, VOID, VOID, VOID, VOID, [2, 1, 0, 4, 3]);
initMetadataForClass(standardVfs$1);
protoOf(StandardPaths).abs = appPreferencesFolder;
initMetadataForObject(StandardPaths, 'StandardPaths', VOID, VOID, [StandardPathsBase]);
initMetadataForClass(httpFactory$2$1);
initMetadataForCompanion(Companion_9);
initMetadataForClass(JsRuntime, 'JsRuntime', VOID, VOID, VOID, [1, 4]);
initMetadataForClass(JsRuntimeBrowser, 'JsRuntimeBrowser', JsRuntimeBrowser, VOID, VOID, [1, 4]);
initMetadataForCompanion(Companion_10, VOID, VOID, [1, 4]);
initMetadataForClass(JsRuntimeDeno, 'JsRuntimeDeno', JsRuntimeDeno, VOID, VOID, [1, 4]);
initMetadataForCompanion(Companion_11, VOID, VOID, [1, 4]);
initMetadataForClass(DenoLocalVfs, 'DenoLocalVfs', DenoLocalVfs, VOID, VOID, [2, 1, 4, 0, 3]);
initMetadataForClass(DenoAsyncStreamBase, 'DenoAsyncStreamBase', VOID, VOID, VOID, [4, 1, 0]);
initMetadataForClass(workerImpl$1, VOID, VOID, VOID, VOID, [4]);
initMetadataForClass(Entry, 'Entry');
initMetadataForCompanion(Companion_12);
initMetadataForClass(JSStackTrace, 'JSStackTrace');
//endregion
//region block: init
resourcesVfsDebug = false;
Companion_instance_4 = new Companion_1();
Companion_instance_5 = new Companion_2();
Companion_instance_6 = new Companion_3();
EmptyLineOnce_instance = new EmptyLineOnce();
Indent_instance = new Indent();
Unindent_instance = new Unindent();
INDENTS_instance = new INDENTS();
Companion_instance_10 = new Companion_7();
Companion_instance_11 = new Companion_8();
StandardPaths_instance = new StandardPaths();
Companion_instance_15 = new Companion_12();
//endregion
//region block: exports
export {
  DemoWorkerTask as DemoWorkerTask,
};
export {
  StandardPaths_instance as StandardPaths_instance2erw5i1zlu9ki,
  Companion_getInstance_12 as Companion_getInstance1wxuudhag44vb,
  Companion_instance_11 as Companion_instance3ss15cv8qszpj,
  launchUnscopedAndWait as launchUnscopedAndWait1ewqmsm0exr55,
  delay_0 as delay96dneiach7wb,
  launchImmediately as launchImmediatelylnv8lnistpdy,
  launchImmediately_0 as launchImmediately11za8mkid9pxu,
  launchUnscoped as launchUnscopedpyoa01nqmf1z,
  launchUnscoped_0 as launchUnscoped2lqe6wwpvfo83,
  MountableVfs as MountableVfs3mmbka3zq5l6i,
  UrlVfs_2 as UrlVfs3infs84pplmp3,
  get_localCurrentDirVfs as get_localCurrentDirVfs2lka1gsv26an5,
  get_resourcesVfs as get_resourcesVfs3qrvup7jpy9uc,
  toVfs as toVfsr7ir4p66g1my,
  Resources as Resources1ysf2j4wd5yk7,
  Indenter as Indenterdf10c5coibyi,
  Once as Once1q3lxlgflq3fq,
  get_length as get_length100spxmnpj7nb,
  get_DEBUG_WORKER as get_DEBUG_WORKER2r7zp31jch3ip,
  get_workerImpl as get_workerImpl14jb6v5ie8q11,
};
//endregion
